export const dmtBanks = [
  {
    "BankId": 649,
    "BankName": "A B BANK LIMITED"
  },
  {
    "BankId": 1908,
    "BankName": "ABHINANDAN URBAN CO-OP BANK LTD"
  },
  {
    "BankId": 425,
    "BankName": "ABHINANDAN URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 2,
    "BankName": "ABHYUDAYA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 3,
    "BankName": "ABHYUDAYA MAHILA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1874,
    "BankName": "ABN AMRO CREDIT CARD"
  },
  {
    "BankId": 4,
    "BankName": "ABU DHABI COMMERCIAL BANK"
  },
  {
    "BankId": 157,
    "BankName": "ACBL ASHOKNAGAR COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 5,
    "BankName": "ACE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 441,
    "BankName": "ADAR P.D.PATIL SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 6,
    "BankName": "ADARSH COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 640,
    "BankName": "ADARSH MAHILA MERCNT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1025,
    "BankName": "ADARSH MAHILA NAGARI SAHAKARI BANK"
  },
  {
    "BankId": 1888,
    "BankName": "ADITYA BIRLA IDEA PAYMENTS BANK"
  },
  {
    "BankId": 155,
    "BankName": "AGARTALA COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1835,
    "BankName": "AGRASEN COOPERATIVE URBAN BANK"
  },
  {
    "BankId": 7,
    "BankName": "AHILYADEVI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 8,
    "BankName": "AHMEDABAD MERCANTILE COOPERATIVE BANK"
  },
  {
    "BankId": 154,
    "BankName": "AHMEDNAGAR DIST CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 145,
    "BankName": "AHMEDNAGAR ZILLA PRATHAMIK SHIKSHAK SAHAKARI BANK"
  },
  {
    "BankId": 1827,
    "BankName": "AHMEDNAGAR ZPSS BANK"
  },
  {
    "BankId": 9,
    "BankName": "AIRTEL PAYMENTS BANK LIMITED"
  },
  {
    "BankId": 1823,
    "BankName": "AJANTHA URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 816,
    "BankName": "AJINKYATARA MAHILA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1517,
    "BankName": "AJMER CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 650,
    "BankName": "AKHAND ANAND COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 152,
    "BankName": "AKKAMAHADEVI MAHILA SAHAKARI BANK"
  },
  {
    "BankId": 10,
    "BankName": "AKOLA JANATA COMMERCIAL COOPERATIVE BANK"
  },
  {
    "BankId": 641,
    "BankName": "AKOLA MERCHANT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 642,
    "BankName": "AKOLA MERCHANT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1824,
    "BankName": "AKOLA URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 11,
    "BankName": "ALAPUZHA DISTRICT COOPERATIVE BANK"
  },
  {
    "BankId": 12,
    "BankName": "ALAVI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 828,
    "BankName": "ALIBAG COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 13,
    "BankName": "ALLAHABAD BANK"
  },
  {
    "BankId": 14,
    "BankName": "ALLAHABAD DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 15,
    "BankName": "ALLAHABAD UP GRAMIN BANK"
  },
  {
    "BankId": 16,
    "BankName": "ALMORA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1821,
    "BankName": "ALMORA ZILA SAHAKARI BANK"
  },
  {
    "BankId": 1833,
    "BankName": "AMALNER URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 757,
    "BankName": "AMAN SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 643,
    "BankName": "AMARNATH COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 635,
    "BankName": "AMBAJOGAI PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 758,
    "BankName": "AMBARNATH JAI HIND COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1830,
    "BankName": "AMBEDKAR NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1875,
    "BankName": "AMERICAN EXPRESS CREDIT CARD"
  },
  {
    "BankId": 1834,
    "BankName": "AMRAVATI DCC BANK"
  },
  {
    "BankId": 630,
    "BankName": "AMRAVATI ZILLA MAHILA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1354,
    "BankName": "AMRELI JILLA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 773,
    "BankName": "AMRELI NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 17,
    "BankName": "ANANDA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 637,
    "BankName": "ANDAMAN & NICOBAR STATE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 147,
    "BankName": "ANDARSUL URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 18,
    "BankName": "ANDHRA BANK"
  },
  {
    "BankId": 1847,
    "BankName": "ANDHRA PRADESH GRAMIN VIKAS BANK"
  },
  {
    "BankId": 20,
    "BankName": "ANDHRA PRAGATHI GRAMIN BANK"
  },
  {
    "BankId": 1829,
    "BankName": "ANENDESHWARI NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 1836,
    "BankName": "ANGUL CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 502,
    "BankName": "ANNASAHEB CHOUGULE COOPERATIVE URBAN BANK"
  },
  {
    "BankId": 831,
    "BankName": "ANNASAHEB MAGAR SAHAKARI BANK"
  },
  {
    "BankId": 631,
    "BankName": "ANURADHA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 151,
    "BankName": "AP MAHAJANS COOPERATIVE URBAN BANK"
  },
  {
    "BankId": 1,
    "BankName": "AP MAHESH COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1828,
    "BankName": "AP RAJA MAHESHWARI BANK"
  },
  {
    "BankId": 150,
    "BankName": "AP RAJARAJESWARI MAHILA COOPERATIVE URBAN BANK LIM"
  },
  {
    "BankId": 636,
    "BankName": "APANI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 21,
    "BankName": "APNA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1544,
    "BankName": "APPASAHEB BIRNALE SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 755,
    "BankName": "ARIHANT URBAN CO-OPERATIVA BANK LIMITED"
  },
  {
    "BankId": 23,
    "BankName": "ARIHANT URBAN COOPERATIVE BANK LIMITED, HDFC BANK"
  },
  {
    "BankId": 22,
    "BankName": "ARIHANT URBAN COOPERATIVE BANK LIMITED, YES BANK"
  },
  {
    "BankId": 760,
    "BankName": "ARMY BASE WORKSHOP CREDIT CO PRIMARY BANK LIMITED"
  },
  {
    "BankId": 153,
    "BankName": "AROODH JYOTI PATTAN SAHAKARA BANK"
  },
  {
    "BankId": 149,
    "BankName": "ARUNA SAHAKARA BANK"
  },
  {
    "BankId": 24,
    "BankName": "ARUNACHAL PRADESH COOPERATIVE APEX BANK"
  },
  {
    "BankId": 1846,
    "BankName": "ARUNACHAL PRADESH RURAL BANK"
  },
  {
    "BankId": 632,
    "BankName": "ARVIND SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1852,
    "BankName": "ARYA VART GRAMIN BANK"
  },
  {
    "BankId": 754,
    "BankName": "ASHOK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 25,
    "BankName": "ASSAM GRAMIN VIKASH BANK"
  },
  {
    "BankId": 1825,
    "BankName": "ASSOCIATE COOPERATIVE BANK"
  },
  {
    "BankId": 639,
    "BankName": "ASTHA MAHILA NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 1832,
    "BankName": "ASTHA MAHILA NAGRIK SAHAKARI BANK MARYADIT"
  },
  {
    "BankId": 26,
    "BankName": "AU SMALL FINANCE BANK LIMITED"
  },
  {
    "BankId": 1822,
    "BankName": "AURANGABAD DCC BANK"
  },
  {
    "BankId": 1916,
    "BankName": "AURANGABAD DCC BANK HO"
  },
  {
    "BankId": 851,
    "BankName": "AURANGABAD DIST CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 27,
    "BankName": "AUSTRALIA AND NEW ZEALAND BANKING GROUP LIMITED"
  },
  {
    "BankId": 32,
    "BankName": "AXIS BANK"
  },
  {
    "BankId": 1861,
    "BankName": "AXIS BANK CREDIT CARD"
  },
  {
    "BankId": 904,
    "BankName": "AZAD URBAN BANK"
  },
  {
    "BankId": 875,
    "BankName": "BAGALKOT DIST CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1394,
    "BankName": "BAGALKOT DISTRICT CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 624,
    "BankName": "BAIDYABATI SHEORAPHULI COOPERATIVE BANK"
  },
  {
    "BankId": 168,
    "BankName": "BALAGERIA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 609,
    "BankName": "BALASINOR NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1818,
    "BankName": "BALASORE COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1853,
    "BankName": "BALIA ETAWA GRAMIN BANK"
  },
  {
    "BankId": 169,
    "BankName": "BALLY COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 170,
    "BankName": "BALOTRA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 171,
    "BankName": "BALTIKURI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 867,
    "BankName": "BALUSSERY COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 172,
    "BankName": "BANARAS MERCANTILE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1353,
    "BankName": "BANASKANTHA DISTRICT CENTRAL COOPERATIVE BANK LIMI"
  },
  {
    "BankId": 338,
    "BankName": "BANASKANTHA MERCANTILE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1887,
    "BankName": "banda district co-operative bank ltd"
  },
  {
    "BankId": 1810,
    "BankName": "BANDA URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 174,
    "BankName": "BANDHAN BANK LIMITED"
  },
  {
    "BankId": 941,
    "BankName": "BANGALORE CITY COOPERATIVE BANK"
  },
  {
    "BankId": 1411,
    "BankName": "BANGALORE RURAL RAMANAGAR COOPERATIVE BANK"
  },
  {
    "BankId": 175,
    "BankName": "BANGIYA GRAMIN VIKASH BANK"
  },
  {
    "BankId": 177,
    "BankName": "BANK OF AMERICA"
  },
  {
    "BankId": 178,
    "BankName": "BANK OF BAHARAIN AND KUWAIT"
  },
  {
    "BankId": 179,
    "BankName": "BANK OF BARODA"
  },
  {
    "BankId": 1862,
    "BankName": "BANK OF BARODA CREDIT CARD"
  },
  {
    "BankId": 180,
    "BankName": "BANK OF CEYLON"
  },
  {
    "BankId": 181,
    "BankName": "BANK OF INDIA"
  },
  {
    "BankId": 184,
    "BankName": "BANK OF MAHARASHTRA"
  },
  {
    "BankId": 185,
    "BankName": "BANK OF TOKYO MITSUBISHI LIMITED"
  },
  {
    "BankId": 186,
    "BankName": "BANKURA TOWN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 187,
    "BankName": "BAPUJI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 188,
    "BankName": "BARAMULLA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1489,
    "BankName": "BARAN KENDRIYA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 613,
    "BankName": "BARAN NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 189,
    "BankName": "BARCLAYS BANK"
  },
  {
    "BankId": 1878,
    "BankName": "BARCLAYS BANK CREDIT CARD"
  },
  {
    "BankId": 1351,
    "BankName": "BARODA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 190,
    "BankName": "BARODA GUJARAT GRAMIN BANK"
  },
  {
    "BankId": 191,
    "BankName": "BARODA RAJASTHAN GRAMIN BANK"
  },
  {
    "BankId": 192,
    "BankName": "BARODA UTTAR PRADESH GRAMIN BANK"
  },
  {
    "BankId": 462,
    "BankName": "BASODA NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 193,
    "BankName": "BASSEIN CATHOLIC COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 752,
    "BankName": "BASTI ZILA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 194,
    "BankName": "BEAWAR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 158,
    "BankName": "BELAGAVI SHREE BASAVESHWAR COOPERATIVE BANK"
  },
  {
    "BankId": 619,
    "BankName": "BELGAUM INDUSTRIAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 883,
    "BankName": "BELGAUM ZILLA RANI CHANNAMMA MAHILA SAHAKARI BANK"
  },
  {
    "BankId": 886,
    "BankName": "BELLAD BAGEWADI URBAN SOUHARD SAHAKARI BANK"
  },
  {
    "BankId": 1817,
    "BankName": "BERHAMPUR CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 138,
    "BankName": "BETUL NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 1816,
    "BankName": "BHADOHI URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1132,
    "BankName": "BHADRADRI COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 612,
    "BankName": "BHAGINI NIVEDITA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 623,
    "BankName": "BHAGYODAYA FRIENDS UR COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 195,
    "BankName": "BHARAT COOPERATIVE BANK MUMBAI LIMITED"
  },
  {
    "BankId": 606,
    "BankName": "BHARATHIYA SAHAKARA BANK"
  },
  {
    "BankId": 1567,
    "BankName": "BHARATI SAHAKARI BANK"
  },
  {
    "BankId": 1352,
    "BankName": "BHARUCH DISTRICT CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1629,
    "BankName": "BHATPARA NAIHATI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 144,
    "BankName": "BHAUSAHEB BIRAJDAR NAGARI SAHAKARI BANK"
  },
  {
    "BankId": 753,
    "BankName": "BHAUSAHEB BIRAJDAR NAGARI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1812,
    "BankName": "BHAVANA RISHI COOPERATIVE BANK"
  },
  {
    "BankId": 780,
    "BankName": "BHAVANI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 749,
    "BankName": "BHAVANI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1350,
    "BankName": "BHAVNAGAR DISTRICT CENTRAL COOPERATIVE BANK LIMITE"
  },
  {
    "BankId": 196,
    "BankName": "BHEL EMPLOYEES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 611,
    "BankName": "BHILAI NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 614,
    "BankName": "BHILWARA MAHILA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 622,
    "BankName": "BHILWARA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 608,
    "BankName": "BHIND NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 1542,
    "BankName": "BHINGAR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 204,
    "BankName": "BHOPAL COOPERATIVE CENTRAL BANK LIMITED"
  },
  {
    "BankId": 258,
    "BankName": "BHUJ MERCHANTILE BANK"
  },
  {
    "BankId": 1927,
    "BankName": "BIHAR GRAMIN BANK"
  },
  {
    "BankId": 197,
    "BankName": "BIHAR KSHETRIYA GRAMIN BANK"
  },
  {
    "BankId": 1811,
    "BankName": "BIHAR STATE COOPERATIVE BANK"
  },
  {
    "BankId": 1401,
    "BankName": "BIJAPUR COOPERATIVE CENTRAL BANK LIMITED"
  },
  {
    "BankId": 143,
    "BankName": "BIJAPUR DISTRICT MAHILA COOPERATIVE BANK"
  },
  {
    "BankId": 159,
    "BankName": "BIJAPUR SAHAKARI BANK"
  },
  {
    "BankId": 874,
    "BankName": "BILAGI PATTANA SAHAKARI BANK"
  },
  {
    "BankId": 615,
    "BankName": "BILASA MAHILA NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 610,
    "BankName": "BILASPUR NAGRIK SAHA BANK LIMITED"
  },
  {
    "BankId": 751,
    "BankName": "BIRDEV SAHAKARI BANK"
  },
  {
    "BankId": 1815,
    "BankName": "BIRDEV SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 167,
    "BankName": "BNP PARIBAS BANK"
  },
  {
    "BankId": 173,
    "BankName": "BOLANGIR CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 140,
    "BankName": "BOMBAY MERCANTILE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1819,
    "BankName": "BOUDH COOPERATIVE CENTRAL BANK"
  },
  {
    "BankId": 1814,
    "BankName": "BRAHMADEODADA BANK"
  },
  {
    "BankId": 198,
    "BankName": "BRAHMAWART COMMERCIAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 604,
    "BankName": "BRAMHAPURI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 141,
    "BankName": "BULDANA DISTRICT CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 199,
    "BankName": "CANARA BANK"
  },
  {
    "BankId": 1863,
    "BankName": "CANARA BANK CREDIT CARD"
  },
  {
    "BankId": 200,
    "BankName": "CAPITAL SMALL FINANCE BANK LIMITED"
  },
  {
    "BankId": 201,
    "BankName": "CATHOLIC SYRIAN BANK LIMITED"
  },
  {
    "BankId": 207,
    "BankName": "CENTRAL BANK OF INDIA"
  },
  {
    "BankId": 208,
    "BankName": "CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 209,
    "BankName": "CENTRAL MADHYA PRADESH GRAMIN BANK"
  },
  {
    "BankId": 206,
    "BankName": "CG RAJYA SAHAKRI BANK"
  },
  {
    "BankId": 1022,
    "BankName": "CHAITANYA COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 19,
    "BankName": "CHAITANYA GODAVARI GRAMIN BANK"
  },
  {
    "BankId": 132,
    "BankName": "CHAITANYA MAHILA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 768,
    "BankName": "CHAITANYA MAHILA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 744,
    "BankName": "CHAMOLI ZILA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1805,
    "BankName": "CHARTERED SAHAKARI BANK NIYAMITHA"
  },
  {
    "BankId": 1131,
    "BankName": "CHEMBUR NAGARIK SAHAKARI BANK"
  },
  {
    "BankId": 210,
    "BankName": "CHHATTISGARH GRAMIN BANK"
  },
  {
    "BankId": 1808,
    "BankName": "CHIKHLI URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1402,
    "BankName": "CHIKMAGALUR DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 211,
    "BankName": "CHINATRUST COMMERCIAL BANK LIMITED"
  },
  {
    "BankId": 1568,
    "BankName": "CHIPLUN URBAN BANK"
  },
  {
    "BankId": 1409,
    "BankName": "CHITRADURGA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1510,
    "BankName": "CHITTORGARH CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 595,
    "BankName": "CHITTORGARH URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 597,
    "BankName": "CHOPDA PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 419,
    "BankName": "CHURU ZILA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 594,
    "BankName": "CHURUZILA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 212,
    "BankName": "CITI BANK"
  },
  {
    "BankId": 1879,
    "BankName": "CITIBANK CREDIT CARD"
  },
  {
    "BankId": 213,
    "BankName": "CITIZEN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 214,
    "BankName": "CITIZEN CREDIT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1806,
    "BankName": "CITIZENS COOPERATIVE BANK"
  },
  {
    "BankId": 215,
    "BankName": "CITIZENS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1809,
    "BankName": "CITIZENS URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 216,
    "BankName": "CITY COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 217,
    "BankName": "CITY UNION BANK LIMITED"
  },
  {
    "BankId": 413,
    "BankName": "COL R D NIKAM SAINIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 599,
    "BankName": "COLOUR MERCHANT'S COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 218,
    "BankName": "COMMERCIAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 219,
    "BankName": "COMMONWEALTH BANK OF AUSTRALIA"
  },
  {
    "BankId": 220,
    "BankName": "CONTAI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 221,
    "BankName": "CORPORATION BANK"
  },
  {
    "BankId": 1864,
    "BankName": "CORPORATION BANK CREDIT CARD"
  },
  {
    "BankId": 222,
    "BankName": "CREDIT AGRICOLE CORPORATE AND INVESTMENT BANK CALYON BANK"
  },
  {
    "BankId": 223,
    "BankName": "CREDIT SUISEE AG BANK"
  },
  {
    "BankId": 224,
    "BankName": "CUTTACK CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 810,
    "BankName": "D.Y.PATIL SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 124,
    "BankName": "DADASAHEB RAMRAO PATIL COOPERATIVE BANK"
  },
  {
    "BankId": 123,
    "BankName": "DAIVADNYA SAHAKARA BANK"
  },
  {
    "BankId": 582,
    "BankName": "DAIVADNYA SAHAKARA BANK"
  },
  {
    "BankId": 1936,
    "BankName": "DAKSHIN BIHAR GRAMIN BANK"
  },
  {
    "BankId": 862,
    "BankName": "DAPOLI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 225,
    "BankName": "DARJEELING DISTRICT CENTRAL COOPERATIVE BANK LIMIT"
  },
  {
    "BankId": 579,
    "BankName": "DARUSSALAM COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 743,
    "BankName": "DATTATRAYA MAHARAJ KALAMBE JAOLI SAHAKARI BANK LIM"
  },
  {
    "BankId": 593,
    "BankName": "DAUND URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1491,
    "BankName": "DAUSA KENDRIYA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 226,
    "BankName": "DAUSA URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1395,
    "BankName": "DAVANAGERE CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 128,
    "BankName": "DAVANGERE HARIHAR URBAN SAHAKARI BANK"
  },
  {
    "BankId": 897,
    "BankName": "DAYALBAGH MAHILA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1895,
    "BankName": "DBS"
  },
  {
    "BankId": 227,
    "BankName": "DCB BANK LIMITED"
  },
  {
    "BankId": 584,
    "BankName": "DEENDAYAL N S BANK LIMITED"
  },
  {
    "BankId": 125,
    "BankName": "DEENDAYAL NAGARI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1797,
    "BankName": "DEHRADUN DISTT COOPERATIVE BANK"
  },
  {
    "BankId": 1800,
    "BankName": "DELHI NAGRIK SEH BANK"
  },
  {
    "BankId": 228,
    "BankName": "DENA BANK"
  },
  {
    "BankId": 1891,
    "BankName": "DENA GUJARAT GRAMIN BANK"
  },
  {
    "BankId": 1913,
    "BankName": "DENA GUJARAT GRAMIN BANK"
  },
  {
    "BankId": 127,
    "BankName": "DEOGHAR JAMATRA CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 1799,
    "BankName": "DEOGIRI NAGARI SAHAKARI BANK"
  },
  {
    "BankId": 229,
    "BankName": "DEOGIRI NAGARI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 230,
    "BankName": "DEORIA KASIA DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 231,
    "BankName": "DEPOSIT INSURANCE AND CREDIT GUARANTEE CORPORATION"
  },
  {
    "BankId": 585,
    "BankName": "DESAIGANJ NAGARI COOPERATIVE BANK"
  },
  {
    "BankId": 232,
    "BankName": "DEUSTCHE BANK"
  },
  {
    "BankId": 233,
    "BankName": "DEVELOPMENT BANK OF SINGAPORE"
  },
  {
    "BankId": 1801,
    "BankName": "DEVELOPMENT COOPERATIVE BANK"
  },
  {
    "BankId": 590,
    "BankName": "DEVI GAYATRI COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 234,
    "BankName": "DEVIKA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 363,
    "BankName": "DEVYANI SAHAKARI BANK"
  },
  {
    "BankId": 182,
    "BankName": "DHAKURIA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 235,
    "BankName": "DHANALAKSHMI BANK"
  },
  {
    "BankId": 122,
    "BankName": "DHANASHREE URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 795,
    "BankName": "DHULE AND NANDURBAR DISTRICT CENTRAL COOPERATIVE B"
  },
  {
    "BankId": 126,
    "BankName": "DHULE AND NANDURBAR JILHA SARKARI BANK"
  },
  {
    "BankId": 121,
    "BankName": "DHULE VIKAS SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 589,
    "BankName": "DILIP URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1910,
    "BankName": "District Co Operative Bank Ltd Faizabad"
  },
  {
    "BankId": 236,
    "BankName": "DISTRICT COOPERATIVE BANK"
  },
  {
    "BankId": 725,
    "BankName": "DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1804,
    "BankName": "DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1892,
    "BankName": "District Cooperative Bank limited"
  },
  {
    "BankId": 237,
    "BankName": "DOHA BANK"
  },
  {
    "BankId": 940,
    "BankName": "DOHA BANK"
  },
  {
    "BankId": 238,
    "BankName": "DOMBIVLI NAGARI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 633,
    "BankName": "DR BABASAHEB AMBEDKAR SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 628,
    "BankName": "DR BABASAHEB AMBEDKAR UR COOPERATIVE BANK"
  },
  {
    "BankId": 129,
    "BankName": "DR BABASAHEB AMBEDKAR URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 108,
    "BankName": "DR JAIPRAKASH MUNDADA URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 239,
    "BankName": "DUMKA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 586,
    "BankName": "DURGAPUR MAHILA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 240,
    "BankName": "DURGAPUR STEEL PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 742,
    "BankName": "DWARKADAS MANTRI NAGARI SAHAKARI BANK"
  },
  {
    "BankId": 1843,
    "BankName": "ELLAQUAI DEHATI BANK"
  },
  {
    "BankId": 241,
    "BankName": "EQUITAS SMALL FINANCE BANK LIMITED"
  },
  {
    "BankId": 242,
    "BankName": "ESAF SMALL FINANCE BANK LIMITED"
  },
  {
    "BankId": 243,
    "BankName": "ETAH DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 244,
    "BankName": "ETAH URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 245,
    "BankName": "ETAWAH DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 575,
    "BankName": "ETAWAH URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 578,
    "BankName": "EXCELLENT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 246,
    "BankName": "EXPORT IMPORT BANK OF INDIA"
  },
  {
    "BankId": 247,
    "BankName": "FATEHPUR DISTRICT COOPERATIVE BANK"
  },
  {
    "BankId": 259,
    "BankName": "FEDERAL BANK"
  },
  {
    "BankId": 1794,
    "BankName": "FINANCIAL COOPERATIVE BANK"
  },
  {
    "BankId": 260,
    "BankName": "FINCARE SMALL FINANCE BANK LIMITED"
  },
  {
    "BankId": 1941,
    "BankName": "Fingrowth Cooperative Bank Ltd"
  },
  {
    "BankId": 261,
    "BankName": "FINO PAYMENTS BANK LIMITED"
  },
  {
    "BankId": 262,
    "BankName": "FIROZABAD DISTRICT CENTRAL COOPERATIVE BANK LIMITE"
  },
  {
    "BankId": 120,
    "BankName": "FIROZABAD ZILA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 263,
    "BankName": "FIRSTRAND BANK LIMITED"
  },
  {
    "BankId": 739,
    "BankName": "GAJANAN NAGARI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1792,
    "BankName": "GANDHI COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1789,
    "BankName": "GANDHIBAGH SAHAKARI BANK"
  },
  {
    "BankId": 265,
    "BankName": "GANDHIDHAM COOPERATIVE BANK"
  },
  {
    "BankId": 1790,
    "BankName": "GANDHIDHAM MERCANTILE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 571,
    "BankName": "GANDHINAGAR NAG. COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 574,
    "BankName": "GANRAJ NAGARI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1793,
    "BankName": "GARHA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1550,
    "BankName": "GAUTAM SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 565,
    "BankName": "GHOGHAMBA VIBHAG NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1791,
    "BankName": "GODAVARI LAXMI COOPERATIVE BANK"
  },
  {
    "BankId": 1017,
    "BankName": "GODAVARI LAXMI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1787,
    "BankName": "GODAVARI URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 573,
    "BankName": "GODAVARI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 114,
    "BankName": "GODHRA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 738,
    "BankName": "GOMTI NAGARIYA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 569,
    "BankName": "GONDAL NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 264,
    "BankName": "GOPINATH PATIL PARSIK BANK"
  },
  {
    "BankId": 1571,
    "BankName": "GUARDIAN BANK"
  },
  {
    "BankId": 1018,
    "BankName": "GUJARAT AMBUJA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 572,
    "BankName": "GUJARAT MERCANTILE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1398,
    "BankName": "GULBARGA YADAGIR COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 266,
    "BankName": "GULSHAN MERCANTILE URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 116,
    "BankName": "GUNA NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 267,
    "BankName": "GURGAON GRAMIN BANK"
  },
  {
    "BankId": 268,
    "BankName": "HADAGALI URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 269,
    "BankName": "HAMIRPUR DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 111,
    "BankName": "HANAMASAGAR URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1490,
    "BankName": "HANUMANGARH KENDRIYA SAHAKARI BANK"
  },
  {
    "BankId": 270,
    "BankName": "HARDOI DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 271,
    "BankName": "HARDOI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 737,
    "BankName": "HARIHARESHWAR SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 112,
    "BankName": "HASSAN DISTRICT COOPERATIVE CENTRAL BANK"
  },
  {
    "BankId": 1784,
    "BankName": "HAVELI SAHAKARI BANK"
  },
  {
    "BankId": 309,
    "BankName": "HDFC BANK"
  },
  {
    "BankId": 576,
    "BankName": "HDFC BANK LIMITED, EASTERN & NORTH EAST FRONTIER R"
  },
  {
    "BankId": 532,
    "BankName": "HDFC BANK LIMITED, KRISHNA BHIMA SAMRUDDHI LAB"
  },
  {
    "BankId": 303,
    "BankName": "HDFC BANK LIMITED, VAIJANATH APPA SARAF MARAT NSBL"
  },
  {
    "BankId": 293,
    "BankName": "HDFC BANK LIMITED, VASUNDHARA MAHILA N G B L AMBAJ"
  },
  {
    "BankId": 1865,
    "BankName": "HDFC BANK LTD CREDIT CARD"
  },
  {
    "BankId": 1859,
    "BankName": "HIMACHAL GRAMIN BANK"
  },
  {
    "BankId": 653,
    "BankName": "HIMACHAL PRADESH STATE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 832,
    "BankName": "HIMATNAGAR NAGARIK SAHAKARI BANK"
  },
  {
    "BankId": 1783,
    "BankName": "HINDUSTAN SHIPYARD STAFF COOPERATIVE BANK"
  },
  {
    "BankId": 654,
    "BankName": "HSBC BANK"
  },
  {
    "BankId": 1881,
    "BankName": "HSBC CREDIT CARD"
  },
  {
    "BankId": 736,
    "BankName": "HUTATMA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 861,
    "BankName": "HUTATMA SHAHKARI BANK LIMITED"
  },
  {
    "BankId": 656,
    "BankName": "ICICI BANK LIMITED"
  },
  {
    "BankId": 663,
    "BankName": "ICICI BANK LIMITED, VAISHYA NAGARI"
  },
  {
    "BankId": 1866,
    "BankName": "ICICI BANK LTD CREDIT CARD"
  },
  {
    "BankId": 761,
    "BankName": "IDBI BANK"
  },
  {
    "BankId": 785,
    "BankName": "IDBI BANK LIMITED,MHAISAL"
  },
  {
    "BankId": 916,
    "BankName": "IDFC BANK LIMITED"
  },
  {
    "BankId": 918,
    "BankName": "IDUKKI DISTRICT COOPERATIVE BANK"
  },
  {
    "BankId": 917,
    "BankName": "IDUKKI DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 919,
    "BankName": "ILKAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1779,
    "BankName": "IMPERIAL URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 920,
    "BankName": "IMPHAL URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 732,
    "BankName": "INDAPUR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 559,
    "BankName": "INDEPEDENCE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1858,
    "BankName": "INDIA POST PAYMENT BANK"
  },
  {
    "BankId": 921,
    "BankName": "INDIAN BANK"
  },
  {
    "BankId": 924,
    "BankName": "INDIAN OVERSEAS BANK"
  },
  {
    "BankId": 1867,
    "BankName": "INDIAN OVERSEAS BANK CREDIT CARD"
  },
  {
    "BankId": 1014,
    "BankName": "INDIRA MAHILA NAGARI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 556,
    "BankName": "INDIRA MAHILA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 734,
    "BankName": "INDIRA MAHILA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1013,
    "BankName": "INDIRA MAHILA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1782,
    "BankName": "INDORE CLOTH MKT COOPERATIVE BANK"
  },
  {
    "BankId": 733,
    "BankName": "INDORE PARASPAR SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 203,
    "BankName": "INDORE PREMIER COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 555,
    "BankName": "INDORE SWAYAMSIDH MAHILA COOPERATIVE BANK"
  },
  {
    "BankId": 110,
    "BankName": "INDRAPRASTHA SEHKARI BANK LIMITED"
  },
  {
    "BankId": 558,
    "BankName": "INDRAYANI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 735,
    "BankName": "INDRAYANI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 927,
    "BankName": "INDUSIND BANK"
  },
  {
    "BankId": 1900,
    "BankName": "IndusInd Bank CREDIT CARD"
  },
  {
    "BankId": 942,
    "BankName": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA LIMITED"
  },
  {
    "BankId": 943,
    "BankName": "INDUSTRIAL BANK OF KOREA"
  },
  {
    "BankId": 1860,
    "BankName": "ING VYSYA BANK LTD"
  },
  {
    "BankId": 1781,
    "BankName": "INNOVATIVE COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 553,
    "BankName": "INTEGRAL URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 923,
    "BankName": "IOB PANDYAN GRAMA BANK"
  },
  {
    "BankId": 554,
    "BankName": "IRINJALAKUDA TOWN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1626,
    "BankName": "J C COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 907,
    "BankName": "JABALPUR MAHILA NAGRIK SHAKARI BANK"
  },
  {
    "BankId": 944,
    "BankName": "JAGRUTI COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1012,
    "BankName": "JAI BHAVANI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 537,
    "BankName": "JAI TULJA BHAVANI UR BANK COOPERATIVE LIMITED"
  },
  {
    "BankId": 730,
    "BankName": "JAIPRAKASH NARAYAN NAGRI SAHAKARI BANK"
  },
  {
    "BankId": 945,
    "BankName": "JALAUN DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 946,
    "BankName": "JALGAON JANATA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 786,
    "BankName": "JALNA DIST CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 547,
    "BankName": "JALNA MERCHANTS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 552,
    "BankName": "JALORE NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 947,
    "BankName": "JAMIA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 948,
    "BankName": "JAMMU AND KASHMIR BANK LIMITED"
  },
  {
    "BankId": 109,
    "BankName": "JAMMU AND KASHMIR GRAMEEN BANK"
  },
  {
    "BankId": 1348,
    "BankName": "JAMNAGAR DISTRICT CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 949,
    "BankName": "JAMPETA COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1914,
    "BankName": "JANA SMALL FINANCE BANK LTD"
  },
  {
    "BankId": 549,
    "BankName": "JANAKALYAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 950,
    "BankName": "JANAKALYAN SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1775,
    "BankName": "JANALAXMI COOPERATIVE BANK"
  },
  {
    "BankId": 1778,
    "BankName": "JANASEVA COOPERATIVE BANK"
  },
  {
    "BankId": 951,
    "BankName": "JANASEVA SAHAKARI BANK BORIVLI LIMITED"
  },
  {
    "BankId": 952,
    "BankName": "JANASEVA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 550,
    "BankName": "JANATA COOPERATIVE BANK LIMITED, MALEGAON"
  },
  {
    "BankId": 107,
    "BankName": "JANATA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1553,
    "BankName": "JANATA SAHAKARI BANK LIMITED AMRAVATI"
  },
  {
    "BankId": 953,
    "BankName": "JANATHA SEVA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 535,
    "BankName": "JANKALYAN URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 543,
    "BankName": "JANSEVA NAGARI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 536,
    "BankName": "JANSEWA URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 104,
    "BankName": "JANSEWA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 729,
    "BankName": "JANTA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 728,
    "BankName": "JANTA URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 551,
    "BankName": "JATH URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 860,
    "BankName": "JAWAHAR SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 727,
    "BankName": "JAYSINGPUR UDGAON SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1506,
    "BankName": "JHALAWAR KENDRIYA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1854,
    "BankName": "JHARKHAND GRAMIN BANK"
  },
  {
    "BankId": 774,
    "BankName": "JHARKHAND STATE COOPERATIVE BANK"
  },
  {
    "BankId": 541,
    "BankName": "JHARNESHWAR NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 1505,
    "BankName": "JHUNJHUNU KENDRIYA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 546,
    "BankName": "JIJAMATA MAHILA NAG SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 545,
    "BankName": "JIJAMATA MAHILA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 882,
    "BankName": "JIJAMATA MAHILA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1129,
    "BankName": "JIJAU COMMERCIAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 106,
    "BankName": "JILA SAHAKARI KENDRIYA BANK"
  },
  {
    "BankId": 202,
    "BankName": "JILA SAHAKARI KENDRIYA BANK"
  },
  {
    "BankId": 803,
    "BankName": "JIVAJI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1776,
    "BankName": "JIVAN COMM COOPERATIVE BANK"
  },
  {
    "BankId": 955,
    "BankName": "JIVAN COMMERCIAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 544,
    "BankName": "JODHPUR NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1777,
    "BankName": "JOGINDRA CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 956,
    "BankName": "JP MORGAN BANK"
  },
  {
    "BankId": 105,
    "BankName": "JUBILEE HILLS MERCANTILE COOPERATIVE URBAN BANK"
  },
  {
    "BankId": 1347,
    "BankName": "JUNAGADH JILLA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 94,
    "BankName": "KADUTHURUTHY URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1772,
    "BankName": "KAIRA DISTRICT CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 957,
    "BankName": "KALLAPPANNA AWADE ICHALKARANJI JANATA SAHAKARI BAN"
  },
  {
    "BankId": 958,
    "BankName": "KALPARUKSHA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 959,
    "BankName": "KALUPUR COMMERCIAL COOPERATIVE BANK"
  },
  {
    "BankId": 961,
    "BankName": "KALYAN JANATA SAHAKARI BANK"
  },
  {
    "BankId": 512,
    "BankName": "KALYANSAGAR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 962,
    "BankName": "KAMALA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1399,
    "BankName": "KANARA DISTRICT CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 1051,
    "BankName": "KANKARIA MANINAGAR COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 963,
    "BankName": "KANNUR DISTRICT COOPERATIVE BANK"
  },
  {
    "BankId": 827,
    "BankName": "KANNUR DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 720,
    "BankName": "KANPUR ZILLA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 964,
    "BankName": "KAPOL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 965,
    "BankName": "KARAMANA COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 514,
    "BankName": "KARAN URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1764,
    "BankName": "KARMALA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 99,
    "BankName": "KARNALA NAGARI SAHAKARI BANK"
  },
  {
    "BankId": 966,
    "BankName": "KARNATAKA BANK LIMITED"
  },
  {
    "BankId": 1400,
    "BankName": "KARNATAKA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 131,
    "BankName": "KARNATAKA MAHILA SAHAKARI BANK"
  },
  {
    "BankId": 967,
    "BankName": "KARNATAKA VIKAS GRAMIN BANK"
  },
  {
    "BankId": 968,
    "BankName": "KARUR VYSYA BANK"
  },
  {
    "BankId": 1849,
    "BankName": "KASHI GOMTI SAMYUT GRAMIN BANK"
  },
  {
    "BankId": 509,
    "BankName": "KASHIPUR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 533,
    "BankName": "KASHMIR MERCANTILE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1345,
    "BankName": "KATCH DISTRICT CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1774,
    "BankName": "KATIHAR DISTRICT CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 1919,
    "BankName": "Kaveri Grameena Bank"
  },
  {
    "BankId": 1845,
    "BankName": "KAVERI KALPATARU GRAMIN BANK"
  },
  {
    "BankId": 511,
    "BankName": "KAVITA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 969,
    "BankName": "KEB Hana Bank"
  },
  {
    "BankId": 723,
    "BankName": "KEDARNATH URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 823,
    "BankName": "KEMPEGOWDA PATTANA SOUHARDA SAHAKARI BANK"
  },
  {
    "BankId": 970,
    "BankName": "KEONJHAR CENTRAL COOOPERATIVE BANK"
  },
  {
    "BankId": 971,
    "BankName": "KERALA GRAMIN BANK"
  },
  {
    "BankId": 724,
    "BankName": "KHALILABAD NAGAR SAHAKARI BANK LIMITED ICICI BANK"
  },
  {
    "BankId": 1771,
    "BankName": "KHALILABAD NAGAR SAHAKARI BANK YES BANK"
  },
  {
    "BankId": 518,
    "BankName": "KHAMGAON URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 972,
    "BankName": "KHARDAH COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 523,
    "BankName": "KHATRA PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1773,
    "BankName": "KHATTRI COOPERATIVE URBAN BANK"
  },
  {
    "BankId": 1770,
    "BankName": "KHORDA CCB MAHILA BANK"
  },
  {
    "BankId": 1769,
    "BankName": "KHORDA CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 908,
    "BankName": "KHORDHA CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 98,
    "BankName": "KISAN NAGRI SAHAKARI BANK"
  },
  {
    "BankId": 1403,
    "BankName": "KODAGU CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1346,
    "BankName": "KODINAR TALUKA COOPERATIVE BANKING UNION LIMITED"
  },
  {
    "BankId": 974,
    "BankName": "KODOLI URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 521,
    "BankName": "KOHINOOR SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1010,
    "BankName": "KOKAN MERCANTILE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1410,
    "BankName": "KOLAR CHIKKABALLAPUR COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 809,
    "BankName": "KOLHAPUR DISTRICT CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 529,
    "BankName": "KOLHAPUR MAHILA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 975,
    "BankName": "KOLKATA POLICE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 976,
    "BankName": "KONOKLOTA MAHILA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1767,
    "BankName": "KOTA MAHILA NAGRIK BANK"
  },
  {
    "BankId": 527,
    "BankName": "KOTA NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1868,
    "BankName": "KOTAK MAHINDRA BANK CREDIT CARD"
  },
  {
    "BankId": 989,
    "BankName": "KOTAK MAHINDRA BANK LIMITED"
  },
  {
    "BankId": 520,
    "BankName": "KOTESHWARA SAHAKARI BANK"
  },
  {
    "BankId": 102,
    "BankName": "KOTTAKKAL COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1026,
    "BankName": "KOTTAYAM COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1027,
    "BankName": "KOTTAYAM DISTRICT COOPERATIVE BANK"
  },
  {
    "BankId": 800,
    "BankName": "KOYANA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1028,
    "BankName": "KOZHIKODE DISTRICT COOPERATIAVE BANK LIMITED"
  },
  {
    "BankId": 1901,
    "BankName": "KRISHNA GRAMEENA BANK"
  },
  {
    "BankId": 101,
    "BankName": "KRISHNA MERCANTILE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1541,
    "BankName": "KRISHNA PATTANA SAHAKAR BANK NIYAMITHA"
  },
  {
    "BankId": 801,
    "BankName": "KRISHNA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 516,
    "BankName": "KRISHNA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 515,
    "BankName": "KRUSHISEVA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 808,
    "BankName": "KUMBHI KASARI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1128,
    "BankName": "KURLA N S BANK"
  },
  {
    "BankId": 1029,
    "BankName": "KUTCH COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1030,
    "BankName": "KUTTIADY COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 719,
    "BankName": "LAKHIMPUR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1897,
    "BankName": "Lakshmi Vilas bank"
  },
  {
    "BankId": 508,
    "BankName": "LALA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 507,
    "BankName": "LALBAUG COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1842,
    "BankName": "LANGPI DEHANGI RURAL BANK"
  },
  {
    "BankId": 1031,
    "BankName": "LATUR DISTRICT CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1763,
    "BankName": "LAXMI MAHILA NAG SAHAKARI BANK"
  },
  {
    "BankId": 506,
    "BankName": "LAXMI MAHILA NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 91,
    "BankName": "LAXMI SAHAKARI BANK"
  },
  {
    "BankId": 717,
    "BankName": "LAXMI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1032,
    "BankName": "LAXMI VILAS BANK"
  },
  {
    "BankId": 503,
    "BankName": "LAXMI VISHNU SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 718,
    "BankName": "LAXMIBAI MAHILA NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1033,
    "BankName": "LIC COOPERATIVE BANK"
  },
  {
    "BankId": 1034,
    "BankName": "LIC EMPLOYEES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1035,
    "BankName": "LIC OF INDIA STAFF COOPERATIVE BANK"
  },
  {
    "BankId": 1036,
    "BankName": "LILUAH COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1037,
    "BankName": "LOKMANGAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 93,
    "BankName": "LOKNETE DATTAJI PATIL SAHAKARI BANK"
  },
  {
    "BankId": 833,
    "BankName": "LOKNETE DATTAJI PATIL SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1762,
    "BankName": "LOKVIKAS NAGARI SAHAKARI BANK"
  },
  {
    "BankId": 504,
    "BankName": "LONAVALA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1127,
    "BankName": "LUCKNOW URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 92,
    "BankName": "LUNAWADA NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1038,
    "BankName": "M S COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1039,
    "BankName": "M.D. PAWAR PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 205,
    "BankName": "M.P. RAJYA SAHAKARI BANK"
  },
  {
    "BankId": 711,
    "BankName": "MAA SHARDA MAHILA NAGRIK BANK"
  },
  {
    "BankId": 475,
    "BankName": "MADHESHWARI URBAN DEV COOPERATIVE BANK"
  },
  {
    "BankId": 1040,
    "BankName": "MADHYA BHARAT GRAMIN BANK"
  },
  {
    "BankId": 1850,
    "BankName": "MADHYA BIHAR GRAMIN BANK"
  },
  {
    "BankId": 820,
    "BankName": "MAGADH CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1041,
    "BankName": "MAHABHAIRAB COOPERATIVE URBAN BANK"
  },
  {
    "BankId": 1042,
    "BankName": "MAHALAKSHMI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1931,
    "BankName": "MAHANAGAR CO-OP BANK LTD"
  },
  {
    "BankId": 1043,
    "BankName": "MAHANAGAR COOPERATIVE BANK"
  },
  {
    "BankId": 1756,
    "BankName": "MAHANAGAR NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 712,
    "BankName": "MAHARANA PRATAP COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1044,
    "BankName": "MAHARASHTRA GRAMIN BANK"
  },
  {
    "BankId": 1045,
    "BankName": "MAHARASHTRA STATE COOPERATIVE BANK"
  },
  {
    "BankId": 491,
    "BankName": "MAHATAMA FULE DIST URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1046,
    "BankName": "MAHATAMA FULE DISTRICT URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 490,
    "BankName": "MAHATMA FULE DIST UR COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 492,
    "BankName": "MAHAVEER COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 164,
    "BankName": "MAHEMDAVAD URBAN PEOPLES COOPERATIVE BANK"
  },
  {
    "BankId": 1126,
    "BankName": "MAHESH SAHAKARI BANK"
  },
  {
    "BankId": 496,
    "BankName": "MAHESH SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 81,
    "BankName": "MAHESH URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 481,
    "BankName": "MAHESH URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 710,
    "BankName": "MAHESH URBAN COP BANK LIMITED"
  },
  {
    "BankId": 1624,
    "BankName": "MAHILA COOPERATIVE BANK"
  },
  {
    "BankId": 322,
    "BankName": "MAHILA COOPERATIVE NAGARIK BANK LIMITED"
  },
  {
    "BankId": 488,
    "BankName": "MAHILA NAGRIK SAHA BANK"
  },
  {
    "BankId": 483,
    "BankName": "MAHILA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1754,
    "BankName": "MAHILA SAMRIDHI BANK"
  },
  {
    "BankId": 714,
    "BankName": "MAHISHMATI NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 1047,
    "BankName": "MAHOBA URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1757,
    "BankName": "MAKARPURA IND EST COOPERATIVE BANK"
  },
  {
    "BankId": 501,
    "BankName": "MALAD SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1048,
    "BankName": "MALAPPURAM DISTRICT COOPERATIVE BANK"
  },
  {
    "BankId": 476,
    "BankName": "MALVIYA URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 478,
    "BankName": "MALVIYA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1049,
    "BankName": "MALWA GRAMIN BANK"
  },
  {
    "BankId": 1755,
    "BankName": "MAMASAHEB PAWAR SATYAVIJAY COOPERATIVE BANK"
  },
  {
    "BankId": 1404,
    "BankName": "MANDYA DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1050,
    "BankName": "MANGAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 85,
    "BankName": "MANGALDAI NAGAR SAMABAI BANK LIMITED"
  },
  {
    "BankId": 1903,
    "BankName": "MANIPUR RURAL BANK"
  },
  {
    "BankId": 1904,
    "BankName": "MANIPUR RURAL BANK"
  },
  {
    "BankId": 1052,
    "BankName": "MANJERI COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 500,
    "BankName": "MANMAD URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 794,
    "BankName": "MANN DESHI MAHILA SAHAKARI BANK LIMITED, MHASWAD"
  },
  {
    "BankId": 1761,
    "BankName": "MANNDESHI MAHILA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 499,
    "BankName": "MANORAMA COOPERATIVE.BANK LIMITED"
  },
  {
    "BankId": 1698,
    "BankName": "MANSA NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 1133,
    "BankName": "MANSAROVAR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1053,
    "BankName": "MANSING COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1007,
    "BankName": "MANTHA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 484,
    "BankName": "MANVI PATTANA SOUH SAHAKARI BANK"
  },
  {
    "BankId": 497,
    "BankName": "MANWATH UR COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 716,
    "BankName": "MANWATH URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 881,
    "BankName": "MARATHA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 713,
    "BankName": "MARKANDEY NAGARI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1315,
    "BankName": "MARKETYARD COMM COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1054,
    "BankName": "MASHREQ BANK"
  },
  {
    "BankId": 709,
    "BankName": "MATHURA ZILLA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1759,
    "BankName": "MAYURBHANJ CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1760,
    "BankName": "MEGHALAYA COOPERATIVE APEX BANK"
  },
  {
    "BankId": 1841,
    "BankName": "MEGHALAYA RURAL BANK"
  },
  {
    "BankId": 1344,
    "BankName": "MEHSANA DISTRICT CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1055,
    "BankName": "MERCHANTS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 87,
    "BankName": "MERCHANTS LIBERAL COOPERATIVE BANK"
  },
  {
    "BankId": 1906,
    "BankName": "MEWAR AANCHALIK GRAMIN BANK"
  },
  {
    "BankId": 819,
    "BankName": "MIDNAPORE PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1056,
    "BankName": "MILLATH COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1057,
    "BankName": "MIZORAM COOPERATIVE APEX BANK LIMITED"
  },
  {
    "BankId": 1840,
    "BankName": "MIZORAM RURAL BANK"
  },
  {
    "BankId": 1753,
    "BankName": "Mizoram Urban COOPERATIVE Development Bank"
  },
  {
    "BankId": 1058,
    "BankName": "MIZUHO BANK LIMITED"
  },
  {
    "BankId": 487,
    "BankName": "MODEL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 814,
    "BankName": "MOGAVEERA COOPERATIVE BANK"
  },
  {
    "BankId": 1059,
    "BankName": "MOHAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 472,
    "BankName": "MOHOL URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 486,
    "BankName": "MOHOL URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1758,
    "BankName": "MONGHYR DCC BANK LIMITED"
  },
  {
    "BankId": 1060,
    "BankName": "MONGHYR JAMUI CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1061,
    "BankName": "MUDGAL URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1062,
    "BankName": "MUGBERIA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1063,
    "BankName": "MUKTAI COOPERATIVE BANK LIMITED NIPHAD"
  },
  {
    "BankId": 474,
    "BankName": "MUKTAI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1625,
    "BankName": "MURSHIDABAD DIST CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 829,
    "BankName": "MUZAFFARPUR CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 1405,
    "BankName": "MYSORE CHAMARAJANAGAR COOPERATIVE BANK"
  },
  {
    "BankId": 1564,
    "BankName": "MYSORE MERCH COOPERATIVE BANK"
  },
  {
    "BankId": 1008,
    "BankName": "MYSORE SILK CLOTH MERCHANT COOPERATIVE BANK LIMITE"
  },
  {
    "BankId": 868,
    "BankName": "MYSORE ZILLA MAHILA SAHAKARA BANK"
  },
  {
    "BankId": 866,
    "BankName": "NADAPURAM COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1064,
    "BankName": "NADIA DISTRICT CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1839,
    "BankName": "NAGALAND RURAL BANK"
  },
  {
    "BankId": 1751,
    "BankName": "NAGAR SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 877,
    "BankName": "NAGAR SAHAKARI BANK, BANK OF INDIA"
  },
  {
    "BankId": 1742,
    "BankName": "NAGAR SAHAKARI BANK, YES BANK"
  },
  {
    "BankId": 1929,
    "BankName": "NAGAR URBAN CO OPERATIVE BANK"
  },
  {
    "BankId": 1065,
    "BankName": "NAGAR URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1741,
    "BankName": "NAGAR VIKAS SAHAKARI BANK"
  },
  {
    "BankId": 458,
    "BankName": "NAGARIK SAHAKARI BANK"
  },
  {
    "BankId": 888,
    "BankName": "NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 461,
    "BankName": "NAGARIK SAMABAY BANK LIMITED"
  },
  {
    "BankId": 1066,
    "BankName": "NAGAUR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 466,
    "BankName": "NAGINA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 456,
    "BankName": "NAGNATH URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1067,
    "BankName": "NAGPUR NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 40,
    "BankName": "NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 457,
    "BankName": "NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 1857,
    "BankName": "NAINITAL ALMORA KSHETRIYA GRAMIN BANK"
  },
  {
    "BankId": 1923,
    "BankName": "Nainital District Cooperative Bank"
  },
  {
    "BankId": 1748,
    "BankName": "NAKODAR HINDU URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1068,
    "BankName": "NALANDA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 74,
    "BankName": "NALBARI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 460,
    "BankName": "NANDANI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 78,
    "BankName": "NANDED DISCTRICT CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 1909,
    "BankName": "NARMADA JHABUA GRAMIN BANK"
  },
  {
    "BankId": 1926,
    "BankName": "NARMADA MALWA GB-INDORE BR"
  },
  {
    "BankId": 704,
    "BankName": "NARODA NAGRIK COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 468,
    "BankName": "NASHIK DIST GIRNA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1780,
    "BankName": "NASHIK DISTT IMC BANK"
  },
  {
    "BankId": 1747,
    "BankName": "NASHIK JILHA MAHILA BANK"
  },
  {
    "BankId": 463,
    "BankName": "NASHIK JILHA MAHILA VIKAS SAHAKARI BANK"
  },
  {
    "BankId": 1744,
    "BankName": "NASHIK RD DEOLALI BANK"
  },
  {
    "BankId": 1745,
    "BankName": "NASHIK RD DEOLALI VYAPARI SAHAKARI BANK"
  },
  {
    "BankId": 1740,
    "BankName": "NASHIK ZILHA S AND P KARMACHARI BANK"
  },
  {
    "BankId": 1069,
    "BankName": "NATIONAL AUSTRALIA BANK LIMITED"
  },
  {
    "BankId": 1070,
    "BankName": "NATIONAL BANK OF ABU DHABI PJSC"
  },
  {
    "BankId": 1125,
    "BankName": "NATIONAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1071,
    "BankName": "NATIONAL URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1899,
    "BankName": "NATIONAL URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1005,
    "BankName": "NAVABHARAT COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 454,
    "BankName": "NAVANAGARA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 848,
    "BankName": "NAVI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1746,
    "BankName": "NAVNIRMAN COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 464,
    "BankName": "NAVSARJAN INDUSTRIAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1749,
    "BankName": "NE EC RLY EMP PRIMARY COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 467,
    "BankName": "NEELA KRISHNA COOPERATIVE URBAN BANK"
  },
  {
    "BankId": 1072,
    "BankName": "NELLORE COOPERATIVE URBAN BANK"
  },
  {
    "BankId": 1497,
    "BankName": "NEW DHAN MANDI RAI SINGH NAGAR SAHAKARI BANK"
  },
  {
    "BankId": 1073,
    "BankName": "NEW INDIA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 705,
    "BankName": "NIDHI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 826,
    "BankName": "NILESHWAR COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1074,
    "BankName": "NILKANTH COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 471,
    "BankName": "NIRMAL URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 459,
    "BankName": "NISHIGANDHA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 706,
    "BankName": "NISHIGANDHA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1189,
    "BankName": "NIZAMABAD DISTRICT COOPERATIVE CENTRAL BANK LIMITE"
  },
  {
    "BankId": 1075,
    "BankName": "NKGSB COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1076,
    "BankName": "NOBLE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 938,
    "BankName": "NOIDA COMMERCIAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 707,
    "BankName": "NORTH EAST SMALL FINANCE BANK LIMITED"
  },
  {
    "BankId": 1077,
    "BankName": "NORTH MALABAR GRAMIN BANK"
  },
  {
    "BankId": 77,
    "BankName": "NORTHERN RAILWAY PRIMARY COOPERATIVE BANK"
  },
  {
    "BankId": 1743,
    "BankName": "NORTHERN RLY PR COOPERATIVE BANK"
  },
  {
    "BankId": 1942,
    "BankName": "NSDL Payments Bank Limited"
  },
  {
    "BankId": 1078,
    "BankName": "NUTAN NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 802,
    "BankName": "NUTAN SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 76,
    "BankName": "NYAYAMITRA SAHAKARA BANK"
  },
  {
    "BankId": 451,
    "BankName": "ODE URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 922,
    "BankName": "ODISHA GRAMEEN BANK"
  },
  {
    "BankId": 1739,
    "BankName": "OJHAR MERCHANTS BANK"
  },
  {
    "BankId": 1079,
    "BankName": "OMAN INTERNATIONAL BANK SAOG"
  },
  {
    "BankId": 702,
    "BankName": "OMERGA JANTA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 449,
    "BankName": "OMKAR NAGARIYA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1738,
    "BankName": "OMKAR NAGREEYA SAHAKARI BANK KAUSHALPURI"
  },
  {
    "BankId": 1080,
    "BankName": "ORIENTAL BANK OF COMMERCE"
  },
  {
    "BankId": 1802,
    "BankName": "OSMANABAD DIST CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 1556,
    "BankName": "PADMASHREE DR. VITTHALRAO VIKHE PATIL COOPERATIVE"
  },
  {
    "BankId": 448,
    "BankName": "PADMAVATHI COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 71,
    "BankName": "PALAKKAD DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 72,
    "BankName": "PALAMOOR COOPERATIVE URBAN BANK"
  },
  {
    "BankId": 1081,
    "BankName": "PALI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 70,
    "BankName": "PALUS SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1733,
    "BankName": "PANCHKULA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1343,
    "BankName": "PANCHMAHAL DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1732,
    "BankName": "PANCHSHEEL COOPERATIVE BANK"
  },
  {
    "BankId": 1731,
    "BankName": "PANCHSHEEL MERC COOPERATIVE BANK"
  },
  {
    "BankId": 1725,
    "BankName": "PANIPAT URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1727,
    "BankName": "PARASPAR SAHAYAK COOPERATIVE BANK"
  },
  {
    "BankId": 1735,
    "BankName": "PARBHANI DISTRICT CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 999,
    "BankName": "PARNER TALUKA SAINIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 447,
    "BankName": "PARSHWANATH COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1696,
    "BankName": "PARWANOO URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1082,
    "BankName": "PASCHIM BANGA GRAMIN BANK"
  },
  {
    "BankId": 1083,
    "BankName": "PATAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1310,
    "BankName": "PATAN NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 435,
    "BankName": "PATAN NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1084,
    "BankName": "PATLIPUTRA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 894,
    "BankName": "PAVANA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 825,
    "BankName": "PAYANGADI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1085,
    "BankName": "PAYTM PAYMENTS BANK LIMITED"
  },
  {
    "BankId": 1086,
    "BankName": "PAYYANUR COOPERATIVE TOWN BANK LIMITED"
  },
  {
    "BankId": 446,
    "BankName": "PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1087,
    "BankName": "PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 427,
    "BankName": "PEOPLES URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1088,
    "BankName": "PILIBHIT DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 440,
    "BankName": "PIMPALGOAN MER COOPERATIVE BANK"
  },
  {
    "BankId": 893,
    "BankName": "PIMPRI CHINCHWAD SAHAKARI BANK"
  },
  {
    "BankId": 766,
    "BankName": "PITHORAGARH JILA SAHAKARI BANK"
  },
  {
    "BankId": 767,
    "BankName": "PITHORAGARH ZILA SAHAKARI BANK"
  },
  {
    "BankId": 1737,
    "BankName": "POCHAMPALLY COOPERATIVE BANK"
  },
  {
    "BankId": 1089,
    "BankName": "PONDICHERRY STATE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1090,
    "BankName": "PONNAMPET TOWN COOPERATIVE BANK"
  },
  {
    "BankId": 436,
    "BankName": "POORNAWADI NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 445,
    "BankName": "PORBANDAR COMMERCIAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 426,
    "BankName": "PORBANDAR VIBHAGIYA NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1729,
    "BankName": "POSTAL AND RMS EMP COOPERATIVE BANK"
  },
  {
    "BankId": 1091,
    "BankName": "PRAGATHI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1092,
    "BankName": "PRAGATHI KRISHNA GRAMIN BANK"
  },
  {
    "BankId": 1730,
    "BankName": "PRAGATI MAHILA NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 1728,
    "BankName": "PRAGATI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 433,
    "BankName": "PRAGATI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1451,
    "BankName": "PRATAP COOPERATIVE BANK"
  },
  {
    "BankId": 1093,
    "BankName": "PRATHAMA BANK"
  },
  {
    "BankId": 793,
    "BankName": "PRATHAMIC SHIKSHAK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 431,
    "BankName": "PRAVARA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1094,
    "BankName": "PRERANA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1000,
    "BankName": "PRERNA NAGARI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1095,
    "BankName": "PRIME COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 437,
    "BankName": "PRIYADARSHANI MAH NAG SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1001,
    "BankName": "PRIYADARSHANI NAGARI SAHAKARI BANK"
  },
  {
    "BankId": 1918,
    "BankName": "PRIYADARSHANI NAGARI SAHAKARI BANK LTD"
  },
  {
    "BankId": 429,
    "BankName": "PRIYADARSHANI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 68,
    "BankName": "PRIYADARSHINI URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1002,
    "BankName": "PROGRESSIVE COOPERATIVE BANK"
  },
  {
    "BankId": 439,
    "BankName": "PROGRESSIVE MERCANTILE COOPERATIVE BANK"
  },
  {
    "BankId": 428,
    "BankName": "PROGRESSIVE URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1096,
    "BankName": "PT BANK MAYBANK INDONESIA TBK"
  },
  {
    "BankId": 444,
    "BankName": "PUNE CANTONMENT SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 442,
    "BankName": "PUNE DISTRICT CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1907,
    "BankName": "PUNE MERCHANTS CO-OPERATIVE BANK LTD"
  },
  {
    "BankId": 1097,
    "BankName": "PUNE MERCHANTS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 438,
    "BankName": "PUNE MUNICIPALCORPSER COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 783,
    "BankName": "PUNE PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1569,
    "BankName": "PUNE URBAN BANK"
  },
  {
    "BankId": 1098,
    "BankName": "PUNJAB AND MAHARSHTRA COOPERATIVE BANK"
  },
  {
    "BankId": 1099,
    "BankName": "PUNJAB AND SIND BANK"
  },
  {
    "BankId": 1851,
    "BankName": "PUNJAB GRAMIN BANK"
  },
  {
    "BankId": 1100,
    "BankName": "PUNJAB NATIONAL BANK"
  },
  {
    "BankId": 1869,
    "BankName": "PUNJAB NATIONAL BANK CREDIT CARD"
  },
  {
    "BankId": 1734,
    "BankName": "PURNEA DISTRICT CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 1101,
    "BankName": "PURVANCHAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1102,
    "BankName": "PURVANCHAL GRAMIN BANK"
  },
  {
    "BankId": 424,
    "BankName": "QATAR NATIONAL BANK"
  },
  {
    "BankId": 1453,
    "BankName": "R S COOPERATIVE BANK"
  },
  {
    "BankId": 1103,
    "BankName": "RABOBANK INTERNATIONAL"
  },
  {
    "BankId": 1104,
    "BankName": "RAE BARELI DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1105,
    "BankName": "RAICHUR DISTRICT CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 651,
    "BankName": "RAIGAD SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 414,
    "BankName": "RAIGARH NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 1106,
    "BankName": "RAILWAY EMPLOYEE COOPERATIVE BANK"
  },
  {
    "BankId": 317,
    "BankName": "RAIPUR URBAN MERCANTILE CO BANK LIMITED"
  },
  {
    "BankId": 1107,
    "BankName": "RAJADHANI COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 698,
    "BankName": "RAJAPUR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1889,
    "BankName": "RAJARAM BAPU SAHAKARI BANK LTD"
  },
  {
    "BankId": 857,
    "BankName": "RAJARAMBAPU SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1108,
    "BankName": "RAJARSHI SHAHU GOVERMENT SERVANTS COOPERATIVE BANK"
  },
  {
    "BankId": 411,
    "BankName": "RAJARSHI SHAHU SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1109,
    "BankName": "RAJASTHAN MARUDHARA GRAMIN BANK"
  },
  {
    "BankId": 1722,
    "BankName": "RAJDHANI NAGAR SAHAKARI BANK"
  },
  {
    "BankId": 1110,
    "BankName": "RAJGURUNAGAR SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1342,
    "BankName": "RAJKOT DISTRICT CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1111,
    "BankName": "RAJKOT NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 836,
    "BankName": "RAJKOT PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 67,
    "BankName": "RAJMATA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 415,
    "BankName": "RAJPUTANA MAHILA URB COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1720,
    "BankName": "RAJSAMAND URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1454,
    "BankName": "RAMESHWAR COOPERATIVE BANK"
  },
  {
    "BankId": 821,
    "BankName": "RAMGARHIA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 699,
    "BankName": "RAMPUR ZILA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1721,
    "BankName": "RAMRAJYA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1112,
    "BankName": "RANAGHAT PEOPLES COOPERATIVE BANK"
  },
  {
    "BankId": 416,
    "BankName": "RANI LAXMIBAI URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1113,
    "BankName": "RANIGANJ COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 65,
    "BankName": "RATANCHAND SHAH SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 422,
    "BankName": "RATNAGIRI DIST CENT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 781,
    "BankName": "RATNAGIRI DISTRICT CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 1114,
    "BankName": "RATNAGIRI DISTRICT CENTRAL COOPERATIVE BANK LIMIT"
  },
  {
    "BankId": 420,
    "BankName": "RAVI COMMERCIAL UR COP BANK LIMITED"
  },
  {
    "BankId": 1723,
    "BankName": "RAVI COMMERCIAL URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1115,
    "BankName": "RBL BANK LIMITED"
  },
  {
    "BankId": 856,
    "BankName": "RENDAL SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 418,
    "BankName": "RENUKA NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 1116,
    "BankName": "RESERVE BANK OF INDIA"
  },
  {
    "BankId": 66,
    "BankName": "RUKMINI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1856,
    "BankName": "RUSHIKULYA GRAMIN BANK"
  },
  {
    "BankId": 1341,
    "BankName": "SABARKANTHA DISTRICT CENTRAL COOPERATIVE BANK LIMI"
  },
  {
    "BankId": 393,
    "BankName": "SADGURU GAHININATH SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 373,
    "BankName": "SADGURU NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 403,
    "BankName": "SADHANA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1117,
    "BankName": "SAHEBRAO DESHMUKH COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1566,
    "BankName": "SAHYADRI SAHAKARI BANK"
  },
  {
    "BankId": 784,
    "BankName": "SAHYOG URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 996,
    "BankName": "SAHYOG URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 997,
    "BankName": "SAIBABA NAGARI SAHAKARI BANK"
  },
  {
    "BankId": 59,
    "BankName": "SAIBABA NAGARI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 366,
    "BankName": "SAMARTH SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 688,
    "BankName": "SAMARTH SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1702,
    "BankName": "SAMARTH URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 682,
    "BankName": "SAMARTH URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1118,
    "BankName": "SAMATA COOPERATIVE DEVELOPMENT BANK"
  },
  {
    "BankId": 1124,
    "BankName": "SAMATA SAHAKARI BANK"
  },
  {
    "BankId": 696,
    "BankName": "SAMATA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 992,
    "BankName": "SAMATHA MAHILA COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 811,
    "BankName": "SAMPADA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 910,
    "BankName": "SAMRUDDHI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1119,
    "BankName": "SAMRUDDHI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 365,
    "BankName": "SAMRUDDHI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1719,
    "BankName": "SAMTA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 367,
    "BankName": "SANAWAD NAGARIK SAHAKARI BANK"
  },
  {
    "BankId": 765,
    "BankName": "SANDUR PATTANA SOUHARDA SAHAKARI BANK"
  },
  {
    "BankId": 1715,
    "BankName": "SANGHAMITRA COOPERATIVE BANK"
  },
  {
    "BankId": 1716,
    "BankName": "SANGHAMITRA COOPERATIVE URBN BANK"
  },
  {
    "BankId": 791,
    "BankName": "SANGLI DISTRICT PRIMARY TEACHERS COOPERATIVE BANK"
  },
  {
    "BankId": 55,
    "BankName": "SANGLI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 350,
    "BankName": "SANGLI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1120,
    "BankName": "SANGOLA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 54,
    "BankName": "SANMATI SAHAKARI BANK"
  },
  {
    "BankId": 685,
    "BankName": "SANMATI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 383,
    "BankName": "SANMITRA MAHILA NAG SAHAKARI BANK"
  },
  {
    "BankId": 689,
    "BankName": "SANMITRA MAHILA NAGRI SAHAKARI BANK"
  },
  {
    "BankId": 370,
    "BankName": "SANMITRA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 995,
    "BankName": "SANMITRA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 408,
    "BankName": "SANMITRA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 357,
    "BankName": "SANT SOPANKAKA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 58,
    "BankName": "SARAKARI NAUKARARA SAHAKARI BANK"
  },
  {
    "BankId": 378,
    "BankName": "SARASPUR NAGARIK COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1295,
    "BankName": "SARASPUR NAGARIK COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1121,
    "BankName": "SARASWAT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 987,
    "BankName": "SARASWATI SHAKARI BANK LIMITED"
  },
  {
    "BankId": 136,
    "BankName": "SARDAR BHILADWALA PARDI PEOPLE COOPERATIVE BANK"
  },
  {
    "BankId": 395,
    "BankName": "SARDAR GUNJ MERCAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 359,
    "BankName": "SARDAR SINGH NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 343,
    "BankName": "SARDAR VALLABHBHAI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1300,
    "BankName": "SARDARGUNJ MERCANTILE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1855,
    "BankName": "SARVA HARYANA GRAMIN BANK"
  },
  {
    "BankId": 1848,
    "BankName": "SARVA UP GRAMIN BANK"
  },
  {
    "BankId": 817,
    "BankName": "SARVODAYA COOPERATIVE BANK"
  },
  {
    "BankId": 1912,
    "BankName": "SARVODAYA SAH BANK"
  },
  {
    "BankId": 1135,
    "BankName": "SASARAM BHABHUA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1136,
    "BankName": "SATLUJ GRAMIN BANK BATHINDA"
  },
  {
    "BankId": 1893,
    "BankName": "SATPURA NARMADA KSHETRIYA GRAMIN BANK"
  },
  {
    "BankId": 1717,
    "BankName": "SATYASHODHAK SAHAKARI BANK"
  },
  {
    "BankId": 1137,
    "BankName": "SAURASHTRA GRAMIN BANK"
  },
  {
    "BankId": 1500,
    "BankName": "SAWAI MADHOPUR KENDRIYA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 342,
    "BankName": "SAWAI MADHOPUR URBAN COOPERATIVE LIMITED"
  },
  {
    "BankId": 1138,
    "BankName": "SAWANTWADI URBAN COPERATIVE BANK"
  },
  {
    "BankId": 1139,
    "BankName": "SBER BANK"
  },
  {
    "BankId": 1134,
    "BankName": "SBU- MERGED BANKS"
  },
  {
    "BankId": 61,
    "BankName": "SEC MERCANTILE COOPERATIVE URBAN BANK"
  },
  {
    "BankId": 57,
    "BankName": "SEHORE NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1141,
    "BankName": "SEVEN HILLS COOPERATIVE URBAN BANK"
  },
  {
    "BankId": 1705,
    "BankName": "SHAHADA PEOPLES COOPERATIVE BANK"
  },
  {
    "BankId": 1142,
    "BankName": "SHAHJAHANPUR DISTRICT CENTRAL COOPERATIVE BANK LIM"
  },
  {
    "BankId": 991,
    "BankName": "SHAJAPUR NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 382,
    "BankName": "SHANKARRAO MOHITE PATIL SAHAKARI BANK"
  },
  {
    "BankId": 797,
    "BankName": "SHARAD NAGARI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 391,
    "BankName": "SHARAD SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1143,
    "BankName": "SHIGGAON URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1299,
    "BankName": "SHIHORI NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 392,
    "BankName": "SHIHORI NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 368,
    "BankName": "SHIKSHAK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 839,
    "BankName": "SHILLONG COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1701,
    "BankName": "SHIMLA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1408,
    "BankName": "SHIMOGA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1144,
    "BankName": "SHINHAN BANK"
  },
  {
    "BankId": 47,
    "BankName": "SHIVA SAHAKARI BANK"
  },
  {
    "BankId": 369,
    "BankName": "SHIVA SAHAKARI BANK"
  },
  {
    "BankId": 1925,
    "BankName": "SHIVAJI NAGARI PAITHAN"
  },
  {
    "BankId": 406,
    "BankName": "SHIVAJIRAO BHOSALE SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1145,
    "BankName": "SHIVALIK MERCANTILE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 362,
    "BankName": "SHIVAM COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1711,
    "BankName": "SHIVAM SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 397,
    "BankName": "SHIVDAULAT SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 38,
    "BankName": "SHIVSHAKTI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 915,
    "BankName": "SHRAMIK NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 880,
    "BankName": "SHREE BASAVESHWAR COOPERATIVE BANK"
  },
  {
    "BankId": 134,
    "BankName": "SHREE BASAVESHWAR URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 903,
    "BankName": "SHREE BASAVESHWAR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1301,
    "BankName": "SHREE BHAVNAGAR NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 837,
    "BankName": "SHREE BOTAD MERCANTILE COOPERATIVE BANK"
  },
  {
    "BankId": 1337,
    "BankName": "SHREE BOTAD MERCANTILE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 398,
    "BankName": "SHREE CHHANI NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1146,
    "BankName": "SHREE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1714,
    "BankName": "SHREE DHARATI COOPERATIVE BANK"
  },
  {
    "BankId": 1147,
    "BankName": "SHREE DHARTI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 830,
    "BankName": "SHREE GAJANAN LOKSEVA SAHAKARI BANK"
  },
  {
    "BankId": 901,
    "BankName": "SHREE GAJANAN URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 850,
    "BankName": "SHREE GAVISIDDHESHWAR URBAN COOPERATIVE BANK LIMIT"
  },
  {
    "BankId": 567,
    "BankName": "SHREE GVERDHNSNGH RAGUVNSHI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1766,
    "BankName": "SHREE KADI NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 385,
    "BankName": "SHREE LAXMI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1320,
    "BankName": "SHREE LODRA NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 993,
    "BankName": "SHREE MAHAVIR SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 489,
    "BankName": "SHREE MAHUVA NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1296,
    "BankName": "SHREE MORBI NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 62,
    "BankName": "SHREE MURUGHARAJENDRA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1148,
    "BankName": "SHREE PARSWANATH COOPERATIVE BANK"
  },
  {
    "BankId": 364,
    "BankName": "SHREE SAMARTH SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1303,
    "BankName": "SHREE SAVARKUNDLA NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 360,
    "BankName": "SHREE SAVLI NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1302,
    "BankName": "SHREE SAVLI NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1712,
    "BankName": "SHREE SHARADA SAHAKARI BANK"
  },
  {
    "BankId": 983,
    "BankName": "SHREE TALAJA NAGARIK SAHA BANK LIMITED"
  },
  {
    "BankId": 1149,
    "BankName": "SHREE TUKARAM COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1700,
    "BankName": "SHREE VARDHAMAN BANK"
  },
  {
    "BankId": 1277,
    "BankName": "SHREE VIRPUR URBAN SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 680,
    "BankName": "SHREE VYANKATESH COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 345,
    "BankName": "SHREE VYAS DHANVARSHA SAHAKARI BANK"
  },
  {
    "BankId": 341,
    "BankName": "SHREE WARANA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1884,
    "BankName": "SHREYAS GRAMIN BANK"
  },
  {
    "BankId": 409,
    "BankName": "SHRI ADINATH COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 156,
    "BankName": "SHRI ANAND COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 407,
    "BankName": "SHRI ANAND NAGARI SAHAKARI BANK LIMITED, HDFC BANK"
  },
  {
    "BankId": 1718,
    "BankName": "SHRI ANAND NAGARI SAHAKARI BANK, YES BANK"
  },
  {
    "BankId": 756,
    "BankName": "SHRI ARIHANT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1150,
    "BankName": "SHRI BALAJI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 139,
    "BankName": "SHRI BARIA NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 695,
    "BankName": "SHRI BASAVESHWAR SAHAKARI BANK"
  },
  {
    "BankId": 404,
    "BankName": "SHRI BHAILALBHAI CONTRACTOR SMARAK COOPERATIVE BAN"
  },
  {
    "BankId": 621,
    "BankName": "SHRI BHARAT UR COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 401,
    "BankName": "SHRI BHAUSAHEB THORAT AMRUTVAHINI SAHAKARI BANK LI"
  },
  {
    "BankId": 1151,
    "BankName": "SHRI CHHATRAPATI RAJASHRI SHAHU URBAN COOPERATIVE"
  },
  {
    "BankId": 1152,
    "BankName": "SHRI D T PATIL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1015,
    "BankName": "SHRI GAJANAN MAHARAJ URBAN COOPERATIVE BANK LIMITE"
  },
  {
    "BankId": 1565,
    "BankName": "SHRI GANESH SAHAKARI BANK"
  },
  {
    "BankId": 394,
    "BankName": "SHRI GANESH SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 396,
    "BankName": "SHRI GURUSIDDHESHWAR COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1298,
    "BankName": "SHRI JANATA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 835,
    "BankName": "SHRI KADASIDDESHWAR PATTAN SAHAKARI BANK"
  },
  {
    "BankId": 100,
    "BankName": "SHRI KANYAKA NAGARI SAHAKARI BANK"
  },
  {
    "BankId": 1558,
    "BankName": "SHRI KRISHNA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1321,
    "BankName": "SHRI LAXMI MAHILA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 384,
    "BankName": "SHRI LAXMIKRUPA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1153,
    "BankName": "SHRI MAHALAXMI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 83,
    "BankName": "SHRI MAHALAXMI PATTAN SAHAKARA BANK"
  },
  {
    "BankId": 60,
    "BankName": "SHRI MAHANT SHIVAYOGI COOPERATIVE BANK"
  },
  {
    "BankId": 379,
    "BankName": "SHRI MAHAVIR URB COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 380,
    "BankName": "SHRI MAHILA SEWA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 806,
    "BankName": "SHRI PANCHGANGA NAGARI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 371,
    "BankName": "SHRI PATNESHWAR URB COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 56,
    "BankName": "SHRI PRAGATI PATTAN SAHAKARI BANK"
  },
  {
    "BankId": 160,
    "BankName": "SHRI REVANSIDDESHWAR SAHAKARI BANK"
  },
  {
    "BankId": 988,
    "BankName": "SHRI RUKHMINI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 358,
    "BankName": "SHRI SATYAVIJAY SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 355,
    "BankName": "SHRI SAWAMI SAMARATH SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 879,
    "BankName": "SHRI SHANTAPPANNA MIRAJI URBAN COOPERATIVE BANK LI"
  },
  {
    "BankId": 50,
    "BankName": "SHRI SHARAN VEERESHWAR SAHAKARI BANK"
  },
  {
    "BankId": 53,
    "BankName": "SHRI SHIDDESHWAR COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1154,
    "BankName": "SHRI SHIDDHESHWAR COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 344,
    "BankName": "SHRI VAIBHAV LAKSHMI MAHILA NS BANK"
  },
  {
    "BankId": 1155,
    "BankName": "SHRI VEER PULIKESHI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 300,
    "BankName": "SHRI VEERSHAIV COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 46,
    "BankName": "SHRI VIJAY MAHANTESH COOPERATIVE BANK"
  },
  {
    "BankId": 807,
    "BankName": "SHRI YASHWANT SAHAKARI BANK"
  },
  {
    "BankId": 687,
    "BankName": "SHRIMANT MALOJIRAJE SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 855,
    "BankName": "SHRIPAL ALASE KURUNWAD URB COOPERATIVE BANK"
  },
  {
    "BankId": 854,
    "BankName": "SHRIPATRAODADA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 352,
    "BankName": "SHRIRAM URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1708,
    "BankName": "SHUBHLAKSHMI MAH COOPERATIVE BANK"
  },
  {
    "BankId": 356,
    "BankName": "SHUSHRUTI SOUAHRDA SAHAKRA BANK"
  },
  {
    "BankId": 1156,
    "BankName": "SIDDAGANGA URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 390,
    "BankName": "SIDDHESHWAR SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 692,
    "BankName": "SIDDHESHWAR URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1157,
    "BankName": "SIDDHI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 561,
    "BankName": "SIHOR MERCANTILE COOPERATIVE BANK"
  },
  {
    "BankId": 1710,
    "BankName": "SIHOR MERCANTILE COOPERATIVE BANK"
  },
  {
    "BankId": 375,
    "BankName": "SIHOR NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1499,
    "BankName": "SIKAR KENDRIYA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 351,
    "BankName": "SIKAR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1924,
    "BankName": "SIKKIM STATE CO-OPERATIVE BANK LTD"
  },
  {
    "BankId": 1703,
    "BankName": "SIKKIM STATE COOPERATIVE BANK"
  },
  {
    "BankId": 1158,
    "BankName": "SIKKIMSTATE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1709,
    "BankName": "SIND COOPERATIVE URBAN BANK"
  },
  {
    "BankId": 1159,
    "BankName": "SINDHUDURG COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 388,
    "BankName": "SINDHUDURG DIST CENT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 762,
    "BankName": "SIR M VISHWESHARAIAH SAHAKAR BANK"
  },
  {
    "BankId": 1160,
    "BankName": "SIR M VISVESVARAYA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1578,
    "BankName": "SIWAN CNETRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 381,
    "BankName": "SMRITI NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1161,
    "BankName": "SOCIETE GENERALE BANK LIMITED"
  },
  {
    "BankId": 1162,
    "BankName": "SOLAPUR JANATA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 389,
    "BankName": "SOLAPUR SIDDHESHWAR SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 354,
    "BankName": "SOLAPUR SOCIAL URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 402,
    "BankName": "SONALI BANK LIMITED"
  },
  {
    "BankId": 374,
    "BankName": "SONBHADRA NAGAR SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 990,
    "BankName": "SONPETH NAGARI SAHAKARI BANK"
  },
  {
    "BankId": 898,
    "BankName": "SOUBHAGYA MAHILA SOUHARDHA SAHAKARI BANK"
  },
  {
    "BankId": 1163,
    "BankName": "SOUTH INDIAN BANK"
  },
  {
    "BankId": 934,
    "BankName": "SREE CHARAN BANK"
  },
  {
    "BankId": 1164,
    "BankName": "SREE CHARAN SOUHARDHA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1549,
    "BankName": "SREE MAHAYOGI LAKSHAMMA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 146,
    "BankName": "SREE MAHAYOGI LAKSHMAMMA COOPERATIVE BANK"
  },
  {
    "BankId": 1165,
    "BankName": "SREE SUBRAMANYESWARA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1166,
    "BankName": "SREE THYAGARAJA COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 929,
    "BankName": "SREENIDHI SOUH BANK"
  },
  {
    "BankId": 930,
    "BankName": "SREENIDHI SOUH SAHAK BANK"
  },
  {
    "BankId": 1167,
    "BankName": "SREENIVASA PADMAVATHI COOPERATIVE BANK"
  },
  {
    "BankId": 64,
    "BankName": "SRI AMBABHAVANI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 935,
    "BankName": "SRI BANASHANKAR MAHILA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 135,
    "BankName": "SRI BASAVESHWAR PATTANA SAHAKARI BANK"
  },
  {
    "BankId": 405,
    "BankName": "SRI BHAGAVATHI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 601,
    "BankName": "SRI CHANNABASAVASWAMY BANK"
  },
  {
    "BankId": 763,
    "BankName": "SRI CHATRAPATI SHIVAJI SAHAKARI BANK"
  },
  {
    "BankId": 1552,
    "BankName": "SRI GANAPATHI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1168,
    "BankName": "SRI GANESH COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1169,
    "BankName": "SRI GAYATRI COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1170,
    "BankName": "SRI GOKARNATH COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 764,
    "BankName": "SRI GURU RAGHAVENDRA SAHAKARA BANK"
  },
  {
    "BankId": 691,
    "BankName": "SRI KALIDASA SAHAKARA BANK"
  },
  {
    "BankId": 387,
    "BankName": "SRI KANNIKAPARAMESWARI COOPBANK LIMITED"
  },
  {
    "BankId": 933,
    "BankName": "SRI LAKSHMI MAHILA SAHAKARI BANK"
  },
  {
    "BankId": 932,
    "BankName": "SRI LAKSHMINARAYANA COOPERATIVE BANK"
  },
  {
    "BankId": 1171,
    "BankName": "SRI POTTI SRI RAMULU NELLORE DISTRICT COOPERATIVE"
  },
  {
    "BankId": 1172,
    "BankName": "SRI RAMA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1548,
    "BankName": "SRI SATYA SAI NAGARIK SAHAKARI BANK"
  },
  {
    "BankId": 51,
    "BankName": "SRI SEETHARAGHAVA SOUHARDA SAHAKARI BANK"
  },
  {
    "BankId": 928,
    "BankName": "SRI SHARADA MAHILA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1173,
    "BankName": "SRI SHARADA MAHILA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 52,
    "BankName": "SRI SHIVESHWAR NAGRI SAHAKARI BANK"
  },
  {
    "BankId": 1174,
    "BankName": "SRI SUDHA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1175,
    "BankName": "SRI VASAVAMBA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 931,
    "BankName": "SRIMATHA MAHILA SAHAKARI BANK"
  },
  {
    "BankId": 840,
    "BankName": "SRIRAMANAGAR PATTANA SAHAKARA BANK"
  },
  {
    "BankId": 361,
    "BankName": "SSMS URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 49,
    "BankName": "STAMBADRI COOPERATIVE URBAN BANK"
  },
  {
    "BankId": 1176,
    "BankName": "STANDARD CHARTERED BANK"
  },
  {
    "BankId": 1882,
    "BankName": "STANDARD CHARTERED CREDIT CARD"
  },
  {
    "BankId": 914,
    "BankName": "STANDARD URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1885,
    "BankName": "STATE BANK OF HYDERABAD, DECCAN GRAMEENA BANK"
  },
  {
    "BankId": 1177,
    "BankName": "STATE BANK OF INDIA"
  },
  {
    "BankId": 1870,
    "BankName": "STATE BANK OF INDIA CREDIT CARD"
  },
  {
    "BankId": 1905,
    "BankName": "STATE BANK OF INDIA HYDERABAD"
  },
  {
    "BankId": 1178,
    "BankName": "STATE BANK OF MAURITIUS LIMITED"
  },
  {
    "BankId": 776,
    "BankName": "STATE TRANSPORT BANK"
  },
  {
    "BankId": 1456,
    "BankName": "STATE TRANSPORT BANK MUMBAI CENTRAL"
  },
  {
    "BankId": 775,
    "BankName": "STATE TRANSPORT COOPERATIVE BANK"
  },
  {
    "BankId": 353,
    "BankName": "STERLING URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 386,
    "BankName": "SUBHADRA LOCAL AREA BANK LIMITED"
  },
  {
    "BankId": 348,
    "BankName": "SUCO SOUHARDA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 347,
    "BankName": "SUDHA COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 681,
    "BankName": "SULAIMANI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 410,
    "BankName": "SUMERPUR MERC. URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1179,
    "BankName": "SUMITOMO MITSUI BANKING CORPORATION"
  },
  {
    "BankId": 1122,
    "BankName": "SUNDARLAL SAVJI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1123,
    "BankName": "SUNDARLAL SAWJI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1707,
    "BankName": "SURAT MERC COOPERATIVE BANK"
  },
  {
    "BankId": 377,
    "BankName": "SURAT NATIONAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1340,
    "BankName": "SURENDRANAGAR DISTRICT CENTRAL COOPERATIVE BANK LI"
  },
  {
    "BankId": 1180,
    "BankName": "SURYODAY SMALL FINANCE BANK LIMITED"
  },
  {
    "BankId": 1181,
    "BankName": "SUTEX COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1182,
    "BankName": "SUVARNA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 346,
    "BankName": "SUVARNAYUG SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 871,
    "BankName": "SWARNA BHARATHI SAHAKARA BANK"
  },
  {
    "BankId": 1183,
    "BankName": "SYNDICATE BANK"
  },
  {
    "BankId": 1871,
    "BankName": "SYNDICATE BANK CREDIT CARD"
  },
  {
    "BankId": 1623,
    "BankName": "T G C COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 824,
    "BankName": "TALIPARAMBA COOPERATIVE URBAN BANK"
  },
  {
    "BankId": 1184,
    "BankName": "TAMILNAD MERCANTILE BANK LIMITED"
  },
  {
    "BankId": 1896,
    "BankName": "TAMILNADU GRAMA BANK"
  },
  {
    "BankId": 1185,
    "BankName": "TAMLUK GHATAL CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1186,
    "BankName": "TARAPUR COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1187,
    "BankName": "TEACHERS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 674,
    "BankName": "TEHRI GARHWAL ZILA SAHAKARI BANK LIMITED, ICICI BA"
  },
  {
    "BankId": 772,
    "BankName": "TEHRI GARHWAL ZILA SAHAKARI BANK, IDBI BANK"
  },
  {
    "BankId": 1190,
    "BankName": "TELANGANA GRAMEEN BANK"
  },
  {
    "BankId": 1188,
    "BankName": "TELANGANA STATE COOPERATIVE BANK APEX BANK"
  },
  {
    "BankId": 670,
    "BankName": "TERNA NAGARI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 315,
    "BankName": "TEXTILE TRADERS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1191,
    "BankName": "THA UTTARPARA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 669,
    "BankName": "THASRA PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1193,
    "BankName": "THE A.P. MAHESH COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1194,
    "BankName": "THE ADARSH COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1195,
    "BankName": "THE ADILABAD DISTRICT COOPERATIVE CENTRAL BANK LIM"
  },
  {
    "BankId": 645,
    "BankName": "THE ADINATH COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1837,
    "BankName": "THE ADINATH COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 340,
    "BankName": "THE AGRASEN NAGARI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1196,
    "BankName": "THE AGROHA COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 644,
    "BankName": "THE AGS EMPLOYEES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 759,
    "BankName": "THE AHMEDNAGAR DIST CEN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 495,
    "BankName": "THE AHMEDNAGAR MER COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 863,
    "BankName": "THE AJARA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1197,
    "BankName": "THE AKKI ALUR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1198,
    "BankName": "THE AKOLA DISTRICT CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 1199,
    "BankName": "THE ALLEPPEY URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1200,
    "BankName": "THE ALMEL URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1201,
    "BankName": "THE ALNAVAR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1516,
    "BankName": "THE ALWAR CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1202,
    "BankName": "THE AMBALA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1545,
    "BankName": "THE AMBIKA MAHILA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1339,
    "BankName": "THE AMOD NAGRIC COOPEARATIVE BANK LIMITED, GUJRAT"
  },
  {
    "BankId": 638,
    "BankName": "THE AMOD NAGRIK COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1203,
    "BankName": "THE AMRITSAR CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 679,
    "BankName": "THE ANAND MERCANTILE COOPERATIVE BANK"
  },
  {
    "BankId": 1204,
    "BankName": "THE ANAND MERCANTILE COOPERATIVE BANK LIMITED, AX"
  },
  {
    "BankId": 1561,
    "BankName": "THE ANANTHPUR COOPERATIVE TOWN BANK"
  },
  {
    "BankId": 1205,
    "BankName": "THE ANDHRA PRADESH STATE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 905,
    "BankName": "THE ANKOLA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 634,
    "BankName": "THE AP JANATA COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1209,
    "BankName": "THE ARSIKERE URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1547,
    "BankName": "THE ARYA VAISHYA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 646,
    "BankName": "THE ARYAPURAM COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 148,
    "BankName": "THE ASKA COOPERATIVE CENTRAL BANK LIMITED"
  },
  {
    "BankId": 648,
    "BankName": "THE ASSAM COOPERATIVE APEX BANK LIMITED"
  },
  {
    "BankId": 864,
    "BankName": "THE ASTHA PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 846,
    "BankName": "THE AZAD COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 750,
    "BankName": "THE BABASAHEB DESHMUKH SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 804,
    "BankName": "THE BABASAHEB DESHMUKH SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 842,
    "BankName": "THE BADAGARA COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1210,
    "BankName": "THE BAGALKOT COOPERATIVE BANK"
  },
  {
    "BankId": 1211,
    "BankName": "THE BAILHONGAL MERCHANTS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 884,
    "BankName": "THE BAILHONGAL URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1396,
    "BankName": "THE BALLARI DISTRICT COOPERATIVE CENTRAL BANK LIMI"
  },
  {
    "BankId": 1212,
    "BankName": "THE BANK OF NOVA SCOTIA"
  },
  {
    "BankId": 1813,
    "BankName": "THE BANKI CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1515,
    "BankName": "THE BANSWARA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 627,
    "BankName": "THE BANTRA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 616,
    "BankName": "THE BAPUNAGAR MAHILA COOPERATIVE BANK"
  },
  {
    "BankId": 1213,
    "BankName": "THE BAPUNAGAR MAHILA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 607,
    "BankName": "THE BARAMATI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 771,
    "BankName": "THE BARDOLI NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1293,
    "BankName": "THE BARDOLI NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1514,
    "BankName": "THE BARMER CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1214,
    "BankName": "THE BARODA CITY COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1215,
    "BankName": "THE BARODA TRADERS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1216,
    "BankName": "THE BATHINDA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 337,
    "BankName": "THE BAVLA NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1024,
    "BankName": "THE BAVLA NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1292,
    "BankName": "THE BECHRAJI NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1217,
    "BankName": "THE BEGUSARAI DISTRICT CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 885,
    "BankName": "THE BELGAUM DIST CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 1218,
    "BankName": "THE BELLARY DISTRICT CENTRAL COOPERATIVE BANK LIMI"
  },
  {
    "BankId": 878,
    "BankName": "THE BELLARY DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1219,
    "BankName": "THE BERHAMPORE COOPERATIVE CENTRAL BANK LIMITED"
  },
  {
    "BankId": 625,
    "BankName": "THE BERHAMPUR COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 602,
    "BankName": "THE BHABHAR VIBHAG NAG SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1338,
    "BankName": "THE BHABHAR VIBHAG NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 748,
    "BankName": "THE BHADGAON PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 137,
    "BankName": "THE BHADRAN PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1220,
    "BankName": "THE BHAGALPUR CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 1221,
    "BankName": "THE BHAGAT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 618,
    "BankName": "THE BHAGYALAKSHMI MAHILA SAHAKARI BANK"
  },
  {
    "BankId": 339,
    "BankName": "THE BHAGYODAYA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 778,
    "BankName": "THE BHANDARA DISTRICT CENTRAL COOPERATIVE BANK LIM"
  },
  {
    "BankId": 620,
    "BankName": "THE BHANDARA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1222,
    "BankName": "THE BHARAT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1513,
    "BankName": "THE BHARATPUR CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1223,
    "BankName": "THE BHATKAL URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 142,
    "BankName": "THE BHAVASAR KSHATRIYA COOPERATIVE BANK"
  },
  {
    "BankId": 1224,
    "BankName": "THE BHAWANIPATNA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1225,
    "BankName": "THE BHIWANI CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1921,
    "BankName": "THE BHIWANI CENTRAL COOPERATIVE BANK LTD"
  },
  {
    "BankId": 165,
    "BankName": "THE BHUJ COMMERCIAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 617,
    "BankName": "THE BHUJ MERCANTILE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 603,
    "BankName": "THE BICHOLIUM URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 629,
    "BankName": "THE BIHAR AWAMI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1226,
    "BankName": "THE BIJNOR URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1227,
    "BankName": "THE BISHNUPUR TOWN COOPERATIVE BANK"
  },
  {
    "BankId": 1228,
    "BankName": "THE BODELI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 336,
    "BankName": "THE BORAL UNION COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1229,
    "BankName": "THE BOTAD PEOPLE S COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1511,
    "BankName": "THE BUNDI CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 605,
    "BankName": "THE BUNDI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 626,
    "BankName": "THE BURDWAN CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1820,
    "BankName": "THE BUSINESS COOPERATIVE BANK"
  },
  {
    "BankId": 1230,
    "BankName": "THE CALICUT COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 841,
    "BankName": "THE CARDAMOM MERCHANTS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 133,
    "BankName": "THE CATHOLIC COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1495,
    "BankName": "THE CENTARAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1512,
    "BankName": "THE CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 652,
    "BankName": "THE CHAMBA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1336,
    "BankName": "THE CHANASMA COMM COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1335,
    "BankName": "THE CHANASMA NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 598,
    "BankName": "THE CHANASMA NAGRIK SAHA. BANK LIMITED"
  },
  {
    "BankId": 745,
    "BankName": "THE CHANDGAD URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1231,
    "BankName": "THE CHANDIGARH STATE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1807,
    "BankName": "THE CHANDRAPUR DCC BANK"
  },
  {
    "BankId": 747,
    "BankName": "THE CHANDWAD MERCHANT S COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1232,
    "BankName": "THE CHANGANACHERRY COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 600,
    "BankName": "THE CHARADA NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 746,
    "BankName": "THE CHEMBUR NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1233,
    "BankName": "THE CHENNAI CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1234,
    "BankName": "THE CHERPALCHERI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 334,
    "BankName": "THE CHHAPI NAGARIK SAHAKARI BANK"
  },
  {
    "BankId": 1334,
    "BankName": "THE CHHAPI NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 596,
    "BankName": "THE CHIKHLI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 678,
    "BankName": "THE CHITNAVISPURA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 130,
    "BankName": "THE CHOPDA PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1509,
    "BankName": "THE CHURU CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 45,
    "BankName": "THE CITIZEN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 813,
    "BankName": "THE CITY COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1235,
    "BankName": "THE CKP COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1236,
    "BankName": "THE COASTAL URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1237,
    "BankName": "THE COIMBATORE DISTRICT CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 335,
    "BankName": "THE COMMERCIAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1023,
    "BankName": "THE COOPERATIVE BANK OF MEHSANA LIMITED"
  },
  {
    "BankId": 1238,
    "BankName": "THE COOPERATIVE BANK OF MEHSANA LIMITED"
  },
  {
    "BankId": 1724,
    "BankName": "THE COOPERATIVE BANK OF RAJKOT"
  },
  {
    "BankId": 1239,
    "BankName": "THE COOPERATIVE CITY BANK LIMITED"
  },
  {
    "BankId": 1240,
    "BankName": "THE COSMOS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1241,
    "BankName": "THE CUDDALORE DISTRICT CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1020,
    "BankName": "THE DAHANU ROAD JANATA COOPERATIVE BANK"
  },
  {
    "BankId": 588,
    "BankName": "THE DAHOD MERCANTILE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1019,
    "BankName": "THE DAHOD MERCANTILE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 580,
    "BankName": "THE DAHOD URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 581,
    "BankName": "THE DARUSSALAM COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 902,
    "BankName": "THE DAVANGERE URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1021,
    "BankName": "THE DECCAN COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1242,
    "BankName": "THE DECCAN MERCHANTS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1798,
    "BankName": "THE DELHI ST COOPERATIVE BANK"
  },
  {
    "BankId": 1243,
    "BankName": "THE DELHI STATE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1244,
    "BankName": "THE DEOLA MERCHANT S COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 677,
    "BankName": "THE DEOLA MERCHANTS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 591,
    "BankName": "THE DEVGAD URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1245,
    "BankName": "THE DHANBAD CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 587,
    "BankName": "THE DHANERA MERCANTILE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 583,
    "BankName": "THE DHARMAJ PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1246,
    "BankName": "THE DHARMAJ PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1247,
    "BankName": "THE DHARMAPURI DISTRICT CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1333,
    "BankName": "THE DHINOJ NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1248,
    "BankName": "THE DHOLPUR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 838,
    "BankName": "THE DHRANGADHRA PEO COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1249,
    "BankName": "THE DHRANGADHRA PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1250,
    "BankName": "THE DINDIGUL CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1939,
    "BankName": "THE DISTRICT CO-OPERATIVE BANK LTD AGRA"
  },
  {
    "BankId": 1917,
    "BankName": "THE DISTRICT COOP CENTRAL BANK LTD BIDAR"
  },
  {
    "BankId": 1252,
    "BankName": "THE DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1208,
    "BankName": "THE DISTRICT COOPERATIVE CENTRAL BANK"
  },
  {
    "BankId": 1397,
    "BankName": "THE DISTRICT COOPERATIVE CENTRAL BANK LIMITED"
  },
  {
    "BankId": 1508,
    "BankName": "THE DUNGARPUR CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1253,
    "BankName": "THE DURGA COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 577,
    "BankName": "THE EENADU COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1796,
    "BankName": "THE ELURI COOPERATIVE URBAN BANK"
  },
  {
    "BankId": 741,
    "BankName": "THE ELURI COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 676,
    "BankName": "THE ELURU URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1254,
    "BankName": "THE ERNAKULAM DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1255,
    "BankName": "THE ERODE DISTRICT CENTRAL COOPERATIVE BANK LIMITE"
  },
  {
    "BankId": 1795,
    "BankName": "THE FAIZ MERCANTILE COOPERATIVE BANK"
  },
  {
    "BankId": 1256,
    "BankName": "THE FARIDABAD CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1257,
    "BankName": "THE FARIDKOT CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1258,
    "BankName": "THE FATEHABAD CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1259,
    "BankName": "THE FATEHGARH SAHIB CENTRAL COOPERATIVE BANK LIMI"
  },
  {
    "BankId": 1260,
    "BankName": "THE FAZILKA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 249,
    "BankName": "THE FEDERAL BANK LIMITED"
  },
  {
    "BankId": 256,
    "BankName": "THE FEDERAL BANK LIMITED, ALWAYE URBAN COOPERATIVE"
  },
  {
    "BankId": 251,
    "BankName": "THE FEDERAL BANK LIMITED, AUCB BR ALENGAD"
  },
  {
    "BankId": 252,
    "BankName": "THE FEDERAL BANK LIMITED, AUCB BR CHUNANGAMVELI"
  },
  {
    "BankId": 1261,
    "BankName": "THE FEROKE COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1262,
    "BankName": "THE FEROZEPUR CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1263,
    "BankName": "THE GADCHIROLI DISTRICT CENTRAL COOPERATIVE BANK L"
  },
  {
    "BankId": 570,
    "BankName": "THE GADCHIROLI NAG SAHAKARI BANK"
  },
  {
    "BankId": 1264,
    "BankName": "THE GADHINGLAJ URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 906,
    "BankName": "THE GANDEVI PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1265,
    "BankName": "THE GANDHI GUNJ COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1266,
    "BankName": "THE GANDHIDHAM COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 939,
    "BankName": "THE GANDHIDHAM MER COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1331,
    "BankName": "THE GANDHIDHAM MERCANTILE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 331,
    "BankName": "THE GANDHINAGAR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 675,
    "BankName": "THE GANESH SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1267,
    "BankName": "THE GANGA MERCANTILE URBAN COOPERATIVE BANK LIMITE"
  },
  {
    "BankId": 1496,
    "BankName": "THE GANGANAGAR KENDRIYA SAHAKARI BANK"
  },
  {
    "BankId": 1268,
    "BankName": "THE GAUHATI COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 333,
    "BankName": "THE GAYATRI COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 568,
    "BankName": "THE GHATAL PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1330,
    "BankName": "THE GHOGHAMBA VIBHAG NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 117,
    "BankName": "THE GHOTI MERCHANTS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 118,
    "BankName": "THE GIRIDIH CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1788,
    "BankName": "THE GOA STATE COOPERATIVE BANK"
  },
  {
    "BankId": 566,
    "BankName": "THE GOA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1269,
    "BankName": "THE GODHRA CITY COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1270,
    "BankName": "THE GODHRA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1271,
    "BankName": "THE GOKAK URBAN COOPERATIVE CREDIT BANK LIMITED"
  },
  {
    "BankId": 119,
    "BankName": "THE GONDIA DISTRICT BANK"
  },
  {
    "BankId": 1546,
    "BankName": "THE GOOTY COOPERATIVE TOWN BANK LIMITED"
  },
  {
    "BankId": 1272,
    "BankName": "THE GOPALGANJ CENTRAL GOPALGANJ COOPERATIVE BANK L"
  },
  {
    "BankId": 332,
    "BankName": "THE GOZARIA NAGARIK SAHAKARI BANK"
  },
  {
    "BankId": 782,
    "BankName": "THE GRAIN MERCHANTS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1273,
    "BankName": "THE GREATER BOMBAY COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 892,
    "BankName": "THE GUDIVADA COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1349,
    "BankName": "THE GUJARAT RAJYA KARMACHARI COOPERATIVE BANK LIMI"
  },
  {
    "BankId": 1308,
    "BankName": "THE GUJARAT STATE CO-OPERATIVE BANK LTD"
  },
  {
    "BankId": 1355,
    "BankName": "THE GUJARAT STATE CO-OPERATIVE BANK LTD"
  },
  {
    "BankId": 844,
    "BankName": "THE GUMLA SIMDEGA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 115,
    "BankName": "THE GUNTUR COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1206,
    "BankName": "THE GUNTUR DIST COOPERATIVE CENTRAL BANK LIMITED"
  },
  {
    "BankId": 1357,
    "BankName": "THE GURDASPUR CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1358,
    "BankName": "THE GURGAON CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 562,
    "BankName": "THE HALOL MERCANTILE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1329,
    "BankName": "THE HALOL URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1291,
    "BankName": "THE HANSOT NAGARIC SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 563,
    "BankName": "THE HANUMANTHANAGAR COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1328,
    "BankName": "THE HARIJ NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1359,
    "BankName": "THE HARYANA STATE COOPERATIVE APEX BANK LIMITED"
  },
  {
    "BankId": 1786,
    "BankName": "THE HASSAN DCC BANK LIMITED"
  },
  {
    "BankId": 1937,
    "BankName": "THE HASSAN DISTRICT CENTRAL CO-OPERATIVE BANK LTD"
  },
  {
    "BankId": 564,
    "BankName": "THE HASTI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1360,
    "BankName": "THE HAVERI URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1361,
    "BankName": "THE HAVERI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 113,
    "BankName": "THE HAZARIBAG CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 1362,
    "BankName": "THE HAZARIBAG CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1363,
    "BankName": "THE HINDU COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1898,
    "BankName": "THE HINDUSTHAN CO OP BANK LIMITED"
  },
  {
    "BankId": 560,
    "BankName": "THE HIRASUGAR EMPLOYEES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1364,
    "BankName": "THE HIRIYUR URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1365,
    "BankName": "THE HISAR CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1366,
    "BankName": "THE HISAR URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1367,
    "BankName": "THE HONAVAR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1368,
    "BankName": "THE HOOGHLY COOPERATIVE CREDIT BANK LIMITED"
  },
  {
    "BankId": 1369,
    "BankName": "THE HOSHIARPUR CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1555,
    "BankName": "THE HOTEL INDUSTRIALISTS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1628,
    "BankName": "THE HOWRAH DISTRICT CENTRAL CO-OPERTAIVE BANK LIMI"
  },
  {
    "BankId": 1785,
    "BankName": "THE HP STATE COOPERATIVE BANK"
  },
  {
    "BankId": 1562,
    "BankName": "THE HUBLI URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 330,
    "BankName": "THE HUKKERI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1890,
    "BankName": "THE HYDERABAD DISTRICT CO OPERATIVE CENTRAL BANK"
  },
  {
    "BankId": 1370,
    "BankName": "THE HYDERABAD DISTRICT COOPERATIVE CENTRAL BANK LI"
  },
  {
    "BankId": 557,
    "BankName": "THE ICHALKARANJI MER COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1327,
    "BankName": "THE IDAR NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 870,
    "BankName": "THE IDAR NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 890,
    "BankName": "THE INCOME TAX DEPT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 865,
    "BankName": "THE INDUSTRIAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1371,
    "BankName": "THE INNESPETA COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 329,
    "BankName": "THE ISLAMPUR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1372,
    "BankName": "THE JAGRUTI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1373,
    "BankName": "THE JAIN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 815,
    "BankName": "THE JAIN SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1374,
    "BankName": "THE JAIPUR CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1493,
    "BankName": "THE JAISALMER CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1375,
    "BankName": "THE JALANDHAR CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1376,
    "BankName": "THE JALGAON DISTRICT CENTRAL COOPERATIVE BANK LIMI"
  },
  {
    "BankId": 1377,
    "BankName": "THE JALGAON PEOPELS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 539,
    "BankName": "THE JALNA PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 540,
    "BankName": "THE JALNA PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1507,
    "BankName": "THE JALORE CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1627,
    "BankName": "THE JALPAIGURI CTRL BANK"
  },
  {
    "BankId": 1325,
    "BankName": "THE JAMBUSAR PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1378,
    "BankName": "THE JAMKHANDI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1326,
    "BankName": "THE JAMNAGAR MAHILA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 328,
    "BankName": "THE JAMNAGAR PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 534,
    "BankName": "THE JAMSHEDPUR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 731,
    "BankName": "THE JANATA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1379,
    "BankName": "THE JANATHA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 889,
    "BankName": "THE JAWHAR URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 895,
    "BankName": "THE JAYNAGAR MOZILPUR PEOPLES COOPERATIVE BANK LIM"
  },
  {
    "BankId": 1380,
    "BankName": "THE JHAJJAR CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 542,
    "BankName": "THE JHALAWAR NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1011,
    "BankName": "THE JHALOD URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1381,
    "BankName": "THE JHALOD URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1382,
    "BankName": "THE JIND CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1504,
    "BankName": "THE JODHPUR CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1383,
    "BankName": "THE JOWAI COOPERATIVE URBAN BANK"
  },
  {
    "BankId": 1384,
    "BankName": "THE JOWAI COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 548,
    "BankName": "THE JUNAGADH COMM COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 859,
    "BankName": "THE KAGAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 726,
    "BankName": "THE KAIRA DISTRICT CENTRAL COOPERATIVE BANK LIMITE"
  },
  {
    "BankId": 1385,
    "BankName": "THE KAITHAL CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1386,
    "BankName": "THE KAKATIYA COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 103,
    "BankName": "THE KAKINADA COOPERATIVE TOWN BANK"
  },
  {
    "BankId": 891,
    "BankName": "THE KAKINADA TOWN COOPERATIVE TOWN BANK"
  },
  {
    "BankId": 519,
    "BankName": "THE KALNA TOWN CREDIT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 843,
    "BankName": "THE KALOL NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 325,
    "BankName": "THE KALOL URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 528,
    "BankName": "THE KALWAN MERCHANTS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1557,
    "BankName": "THE KALWAN MERCHANTS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 43,
    "BankName": "THE KANAKAMAHALAKSHMI COOPERATIVE BANK"
  },
  {
    "BankId": 1387,
    "BankName": "THE KANAKAMAHALAKSHMI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1388,
    "BankName": "THE KANCHIPURAM CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1389,
    "BankName": "THE KANGRA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1390,
    "BankName": "THE KANGRA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1391,
    "BankName": "THE KANNUR COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1392,
    "BankName": "THE KANYAKUMARI DISTRICT CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 524,
    "BankName": "THE KAPADWANJ PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 96,
    "BankName": "THE KAPURTHALA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 530,
    "BankName": "THE KARAD JANATA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1393,
    "BankName": "THE KARAD URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1412,
    "BankName": "THE KARANATAKA STATE COOPERATIVE APEX BANK LIMITED"
  },
  {
    "BankId": 1413,
    "BankName": "THE KARIMNAGAR DISTRICT COOPERATIVE CENTRAL BANK L"
  },
  {
    "BankId": 673,
    "BankName": "THE KARJAN NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1289,
    "BankName": "THE KARJAN NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 522,
    "BankName": "THE KARMALA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1414,
    "BankName": "THE KARNAL CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1415,
    "BankName": "THE KARNATAKA COOPERATIVE BANK LIMITED,"
  },
  {
    "BankId": 985,
    "BankName": "THE KARNAVATI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1416,
    "BankName": "THE KARWAR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1417,
    "BankName": "THE KASARAGOD COOPERATIVE TOWN BANK LIMITED"
  },
  {
    "BankId": 1902,
    "BankName": "THE KASARAGOD DISTRICT CO-OPERATIVE BANK LTD"
  },
  {
    "BankId": 1418,
    "BankName": "THE KASARAGOD DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 517,
    "BankName": "THE KATTAPPANA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 510,
    "BankName": "THE KENDRAPARA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1419,
    "BankName": "THE KERALA MERCANTILE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1420,
    "BankName": "THE KERALA STATE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 822,
    "BankName": "THE KESHAV SEHKARI BANK LIMITED"
  },
  {
    "BankId": 872,
    "BankName": "THE KHAGARIA DISTRICTCENTRAL COOPERATIVE BANK LIMI"
  },
  {
    "BankId": 1323,
    "BankName": "THE KHAMBHAT NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1421,
    "BankName": "THE KHAMMAM DISTRICT COOPERATIVE CENTRAL BANK LIMI"
  },
  {
    "BankId": 722,
    "BankName": "THE KHEDA PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1192,
    "BankName": "THE KHEDA PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1290,
    "BankName": "THE KHERALU NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 526,
    "BankName": "THE KODINAR NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 858,
    "BankName": "THE KODOLI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1422,
    "BankName": "THE KODUNGALLUR TOWN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 513,
    "BankName": "THE KOLHAPUR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1768,
    "BankName": "THE KOLLAM DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 960,
    "BankName": "THE KONARK URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1560,
    "BankName": "THE KOPARGAON PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 97,
    "BankName": "THE KORAPUT CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1324,
    "BankName": "THE KOSAMBA MERC COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1503,
    "BankName": "THE KOTA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1543,
    "BankName": "THE KOVVUR COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 525,
    "BankName": "THE KOYLANCHAL URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1423,
    "BankName": "THE KOZHIKODE DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 95,
    "BankName": "THE KRANTHI COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1207,
    "BankName": "THE KRISHNA DISTRICT COOPERATIVE CENTRAL BANK LIMI"
  },
  {
    "BankId": 531,
    "BankName": "THE KRISHNANAGAR CITY COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 326,
    "BankName": "THE KUKARWADA NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1424,
    "BankName": "THE KUMBAKONAM CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1425,
    "BankName": "THE KUMTA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1765,
    "BankName": "THE KUNBI SAHAKARI BANK"
  },
  {
    "BankId": 721,
    "BankName": "THE KURLA NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1426,
    "BankName": "THE KURMANCHAL NAGAR SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1427,
    "BankName": "THE KURUKSHETRA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 327,
    "BankName": "THE KUTCH MERCANTILE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1322,
    "BankName": "THE LAKHWAD NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1559,
    "BankName": "THE LASALGAON MERCHANTS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 790,
    "BankName": "THE LATUR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 324,
    "BankName": "THE LAXMI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1428,
    "BankName": "THE LAXMI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1429,
    "BankName": "THE LAXMI URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1319,
    "BankName": "THE LIMBASI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1430,
    "BankName": "THE LIMDI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1431,
    "BankName": "THE LUDHIANA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 505,
    "BankName": "THE LUNAWADA PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 485,
    "BankName": "THE MADANAPALLE COOPERATIVE TOWN BANK LIMITED"
  },
  {
    "BankId": 482,
    "BankName": "THE MADGAUM URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1432,
    "BankName": "THE MADURAI DISTRICT CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 798,
    "BankName": "THE MAHABALESHWAR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1433,
    "BankName": "THE MAHABOOBNAGAR DISTRICT COOPERATIVE CENTRAL BAN"
  },
  {
    "BankId": 1434,
    "BankName": "THE MAHANAGAR COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 913,
    "BankName": "THE MAHARAJA COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 323,
    "BankName": "THE MAHAVEER COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 89,
    "BankName": "THE MAHENDERGARH CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 480,
    "BankName": "THE MAHILA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1006,
    "BankName": "THE MAHILA VIKAS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1318,
    "BankName": "THE MAHILA VIKAS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 42,
    "BankName": "THE MAHUDHA NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 82,
    "BankName": "THE MALAD SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1435,
    "BankName": "THE MALEGAON MERCHANT S COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 321,
    "BankName": "THE MALKAPUR URB COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 493,
    "BankName": "THE MALLESWARAM COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1317,
    "BankName": "THE MALPUR NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 498,
    "BankName": "THE MANDAL NAGRIC SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1312,
    "BankName": "THE MANDAL NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 88,
    "BankName": "THE MANDAPETA COOPERATIVE TOWN BANK"
  },
  {
    "BankId": 86,
    "BankName": "THE MANDVI MERCANTILE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1288,
    "BankName": "THE MANDVI NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1436,
    "BankName": "THE MANDYA CITY COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1437,
    "BankName": "THE MANGALORE CATHOLIC COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1438,
    "BankName": "THE MANGALORE COOPERATIVE TOWN BANK LIMITED"
  },
  {
    "BankId": 1752,
    "BankName": "THE MANIPUR WOMEN S COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 79,
    "BankName": "THE MANIPUR WOMENS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 715,
    "BankName": "THE MANJERI COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1439,
    "BankName": "THE MANMANDIR COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1440,
    "BankName": "THE MANSA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1316,
    "BankName": "THE MANSA NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 479,
    "BankName": "THE MAPUSA URB COOPERATIVE BANK OF GOA LIMITED"
  },
  {
    "BankId": 1441,
    "BankName": "THE MATTANCHERRY MAHAJANIK COOPERATIVE BANK LIMITE"
  },
  {
    "BankId": 1442,
    "BankName": "THE MATTANCHERRY SARVAJANIK COOPERATIVE BANK LIMIT"
  },
  {
    "BankId": 671,
    "BankName": "THE MAYANI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1443,
    "BankName": "THE MEDAK DISTRICT COOPERATIVE CENTRAL BANK LIMITE"
  },
  {
    "BankId": 257,
    "BankName": "THE MEENACHIL EAST URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1313,
    "BankName": "THE MEGHRAJ NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 477,
    "BankName": "THE MEHKAR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1444,
    "BankName": "THE MEHMADABAD URBAN PEOPLES COOPERATIVE BANK LIMI"
  },
  {
    "BankId": 1314,
    "BankName": "THE MEHSANA JILLA PANCHAYAT KARMACHARI COOPERATIVE"
  },
  {
    "BankId": 818,
    "BankName": "THE MEHSANA NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1445,
    "BankName": "THE MEHSANA URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 80,
    "BankName": "THE MERCHANT URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 847,
    "BankName": "THE MERCHANTS SOUHARDA SAHAKARA BANK"
  },
  {
    "BankId": 672,
    "BankName": "THE MERCHANTS URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1446,
    "BankName": "THE MODA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1009,
    "BankName": "THE MODASA NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1447,
    "BankName": "THE MODEL COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 494,
    "BankName": "THE MODERN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 84,
    "BankName": "THE MOIRANG PRIMARY COOPERATIVE BANK"
  },
  {
    "BankId": 41,
    "BankName": "THE MOTI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1448,
    "BankName": "THE MOTIHARI CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1449,
    "BankName": "THE MUDALAGI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1450,
    "BankName": "THE MUKTSAR CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1455,
    "BankName": "THE MUMBAI DISTRICT CENTRAL COOPERATIVE BANK LIMIT"
  },
  {
    "BankId": 1457,
    "BankName": "THE MUNICIPAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 90,
    "BankName": "THE MUSLIM COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 473,
    "BankName": "THE MUSLIM COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1458,
    "BankName": "THE MUVATTUPUZHA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 470,
    "BankName": "THE NABADWIP COOPERATIVE CREDIT BANK LIMITED"
  },
  {
    "BankId": 1459,
    "BankName": "THE NABAPALLI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 162,
    "BankName": "THE NADIAD PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 75,
    "BankName": "THE NAGALAND STATE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 163,
    "BankName": "THE NAGAR SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1502,
    "BankName": "THE NAGAUR CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 787,
    "BankName": "THE NAGPUR DIST CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1460,
    "BankName": "THE NAINITAL BANK LIMITED"
  },
  {
    "BankId": 465,
    "BankName": "THE NAKODAR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1461,
    "BankName": "THE NALGONDA DISTRICT COOPERATIVE CENTRAL BANK LIM"
  },
  {
    "BankId": 789,
    "BankName": "THE NANDED MERCHANT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 452,
    "BankName": "THE NANDURA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1004,
    "BankName": "THE NANDURBAR MERCHANTS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 320,
    "BankName": "THE NARODA NAGRIK COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 812,
    "BankName": "THE NASHIK JILHA MAHILA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 708,
    "BankName": "THE NASIK DIST CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1462,
    "BankName": "THE NASIK MERCHANTS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 845,
    "BankName": "THE NATIONAL CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 1464,
    "BankName": "THE NATIONAL COOPERATIVE BANK"
  },
  {
    "BankId": 984,
    "BankName": "THE NATIONAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1465,
    "BankName": "THE NAVAL DOCKYARD COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 703,
    "BankName": "THE NAVJEEVAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1920,
    "BankName": "The Navnirman Co - Op. Bank Ltd."
  },
  {
    "BankId": 1466,
    "BankName": "THE NAVNIRMAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1750,
    "BankName": "THE NAWADA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1467,
    "BankName": "THE NAWANAGAR COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1468,
    "BankName": "THE NAWANSHAHR CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 937,
    "BankName": "THE NEHRUNAGAR COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 469,
    "BankName": "THE NEMMARA COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1469,
    "BankName": "THE NEW AGRA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 453,
    "BankName": "THE NEW URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1470,
    "BankName": "THE NILAMBUR COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1471,
    "BankName": "THE NILGIRIS DISTRICT CENTRAL COOPERATIVE BANK LIM"
  },
  {
    "BankId": 455,
    "BankName": "THE NIPHAD URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1003,
    "BankName": "THE NIPHAD URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1472,
    "BankName": "THE NIZAMABAD DISTRICT COOPERATIVE APEX CENTRAL BA"
  },
  {
    "BankId": 1311,
    "BankName": "THE ODE URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 450,
    "BankName": "THE OJHAR MERCHANTS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1473,
    "BankName": "THE OTTAPALAM COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 73,
    "BankName": "THE PACHHAPUR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 434,
    "BankName": "THE PACHORA PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1307,
    "BankName": "THE PADRA NAGAR NAG SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1474,
    "BankName": "THE PALAMOOR COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1501,
    "BankName": "THE PALI CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1475,
    "BankName": "THE PANCHKULA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1476,
    "BankName": "THE PANCHKULA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 701,
    "BankName": "THE PANDHARPUR MERCHANTS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1477,
    "BankName": "THE PANDHARPUR URBAN COOPERATIVE BANK LIMITED PAN"
  },
  {
    "BankId": 1478,
    "BankName": "THE PANIHATI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1479,
    "BankName": "THE PANIPAT CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 834,
    "BankName": "THE PANVELURBAN COOPERATIVE BANK"
  },
  {
    "BankId": 430,
    "BankName": "THE PATAN URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1285,
    "BankName": "THE PATDI NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1480,
    "BankName": "THE PATHANAMTHITTA DISTRICT COOPERATIVE BANK LIMIT"
  },
  {
    "BankId": 1481,
    "BankName": "THE PATIALA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1482,
    "BankName": "THE PAYYOLI COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1483,
    "BankName": "THE PEOPLE S URBAN COOPERATIVE BANK,"
  },
  {
    "BankId": 319,
    "BankName": "THE PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 700,
    "BankName": "THE PIJ PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1309,
    "BankName": "THE PIJ PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1484,
    "BankName": "THE PIONEER URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 443,
    "BankName": "THE POCHAMPALLY COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 250,
    "BankName": "THE PONANI COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 432,
    "BankName": "THE POSTAL & RMS EMPLOY COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1286,
    "BankName": "THE PRAGATI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 805,
    "BankName": "THE PRATHAMIK SHIKSHAK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 799,
    "BankName": "THE PRITISANGAM SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 69,
    "BankName": "THE PRODDATUR COOPERATIVE TOWN BANK"
  },
  {
    "BankId": 1485,
    "BankName": "THE PUDUKKOTTAI DISTRICT CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 161,
    "BankName": "THE PUNJAB STATE COOPERATIVE BANK"
  },
  {
    "BankId": 1486,
    "BankName": "THE PURNIA DISTRICT CENTRAL COOPERATIVE BANK LIMIT"
  },
  {
    "BankId": 769,
    "BankName": "THE QUILON COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 900,
    "BankName": "THE RADDI SAHAKARA BANK"
  },
  {
    "BankId": 896,
    "BankName": "THE RADHASOMAY URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1487,
    "BankName": "THE RAIGAD DISTRICT CENTRAL COOPERATIVE BANK LIMIT"
  },
  {
    "BankId": 1488,
    "BankName": "THE RAILWAY COOPERATIVE BANK LIMITED, MYSORE"
  },
  {
    "BankId": 697,
    "BankName": "THE RAIPUR URBAN MERCHANT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 421,
    "BankName": "THE RAJAJINAGAR COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 779,
    "BankName": "THE RAJAPUR SAHAKARI BANK"
  },
  {
    "BankId": 1492,
    "BankName": "THE RAJASTHAN STATE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1894,
    "BankName": "THE RAJASTHAN STATE COOPERATIVE BANK LTD"
  },
  {
    "BankId": 1518,
    "BankName": "THE RAJASTHAN URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1519,
    "BankName": "THE RAJKOT COMMERCIAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 417,
    "BankName": "THE RAJLAXMI MAHILA UC BANK LIMITED"
  },
  {
    "BankId": 1304,
    "BankName": "THE RAJPIPLA NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1306,
    "BankName": "THE RAJULA NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1932,
    "BankName": "THE RAMANATHAPURAM DISTRICT CENTRAL CO-OPERATIVE B"
  },
  {
    "BankId": 1520,
    "BankName": "THE RAMANATHAPURAM DISTRICT CENTRAL COOPERATIVE BA"
  },
  {
    "BankId": 1521,
    "BankName": "THE RANCHI KHUNTI CENTRAL COOPERATIVE BANK LIMITE"
  },
  {
    "BankId": 412,
    "BankName": "THE RANDER PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1305,
    "BankName": "THE RANDHEJA COMMERCIAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 998,
    "BankName": "THE RANGA REDDY COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 873,
    "BankName": "THE RANUJ NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 423,
    "BankName": "THE RANUJ NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1883,
    "BankName": "THE RATNAKAR BANK LIMITED CREDIT CARD"
  },
  {
    "BankId": 1522,
    "BankName": "THE RAVER PEOPLES CO -OPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1523,
    "BankName": "THE RAYAT SEVAK COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1554,
    "BankName": "THE REVDANDA COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1524,
    "BankName": "THE REWARI CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 876,
    "BankName": "THE ROHIKA CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 1525,
    "BankName": "THE ROHTAK CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1526,
    "BankName": "THE ROPAR CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1527,
    "BankName": "THE ROYAL BANK OF SCOTLAND N V"
  },
  {
    "BankId": 1294,
    "BankName": "THE SALAL SARVODAY NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1528,
    "BankName": "THE SALEM DISTRICT CENTRAL COOPERATIVE BANK LIMITE"
  },
  {
    "BankId": 1529,
    "BankName": "THE SALUR COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1530,
    "BankName": "THE SAMASTIPUR DISTRICT CENTRAL COOPERATIVE BANK L"
  },
  {
    "BankId": 936,
    "BankName": "THE SAMMCO BANK LIMITED"
  },
  {
    "BankId": 316,
    "BankName": "THE SANGAMNER MERCH COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 792,
    "BankName": "THE SANGLI DISTRICT CENTRAL COOPERATIVE BANK LIMIT"
  },
  {
    "BankId": 1531,
    "BankName": "THE SANGRUR CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 982,
    "BankName": "THE SANKHEDA NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 376,
    "BankName": "THE SANKHEDA NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 1532,
    "BankName": "THE SANTRAGACHI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1533,
    "BankName": "THE SANTRAMPUR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1534,
    "BankName": "THE SARANGPUR COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1297,
    "BankName": "THE SARDAR GUNJ MERC COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 63,
    "BankName": "THE SARDARGANJ MERCANTILE COOPERATIVE BANK LIMITE"
  },
  {
    "BankId": 1535,
    "BankName": "THE SARSA PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 400,
    "BankName": "THE SARVODAYA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1284,
    "BankName": "THE SARVODAYA NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 981,
    "BankName": "THE SARVODAYA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1536,
    "BankName": "THE SAS NAGAR CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 667,
    "BankName": "THE SATANA MERCHANTS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1537,
    "BankName": "THE SATARA DISTRICT CENTRAL COOPERATIVE BANK LIMIT"
  },
  {
    "BankId": 1694,
    "BankName": "THE SATARA SAHAKARI BANK"
  },
  {
    "BankId": 372,
    "BankName": "THE SATHAMBA PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1538,
    "BankName": "THE SAURASHTRA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1539,
    "BankName": "THE SAURASHTRA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 349,
    "BankName": "THE SAVANUR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 690,
    "BankName": "THE SECUNDERABAD MERCANTILE COOPERATIVE URBAN BANK"
  },
  {
    "BankId": 1540,
    "BankName": "THE SEVA VIKAS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 694,
    "BankName": "THE SEVALIA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1551,
    "BankName": "THE SHALINI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1563,
    "BankName": "THE SHAMRAO VITHAL COOPERATIVE BANK"
  },
  {
    "BankId": 1572,
    "BankName": "THE SHIBPUR COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 994,
    "BankName": "THE SHIRPUR PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1573,
    "BankName": "THE SHORANUR COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 683,
    "BankName": "THE SINDAGI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1574,
    "BankName": "THE SINDHUDURG DISTRICT CENTRAL COOPERATIVE BANK L"
  },
  {
    "BankId": 1575,
    "BankName": "THE SINGHBHUM DISTRICT CENTRAL COOPERATIVE BANK LI"
  },
  {
    "BankId": 686,
    "BankName": "THE SINOR NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1498,
    "BankName": "THE SIROHI CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1576,
    "BankName": "THE SIRSA CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 899,
    "BankName": "THE SIRSI URBAN SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 770,
    "BankName": "THE SITAMARHI CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 1577,
    "BankName": "THE SIVAGANGAI DISTRICT CENTRAL COOPERATIVE BANK L"
  },
  {
    "BankId": 399,
    "BankName": "THE SOCIAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1713,
    "BankName": "THE SOLAPUR DIST CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 1579,
    "BankName": "THE SOLAPUR DISTRICT CENTRAL COOPERATIVE BANK LIMI"
  },
  {
    "BankId": 869,
    "BankName": "THE SONEPAT CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1580,
    "BankName": "THE SONEPAT URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1581,
    "BankName": "THE SOUTH CANARA DISTRICT CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 887,
    "BankName": "THE SRI KANNIKAPARAMESHWARI COOPERATIVE BANK LIMIT"
  },
  {
    "BankId": 684,
    "BankName": "THE SSK COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 48,
    "BankName": "THE SUDHA COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1582,
    "BankName": "THE SULTAN S BATTERY COOPERATIVE URBAN BANK"
  },
  {
    "BankId": 1583,
    "BankName": "THE SULTAN?S BATTERY COOPERATIVE URBAN BANK LIMITE"
  },
  {
    "BankId": 1584,
    "BankName": "THE SURAT DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1585,
    "BankName": "THE SURATH PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1586,
    "BankName": "THE SUVIKAS PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1587,
    "BankName": "THE SWASAKTHI MERCANTILE COOPERATIVE URBAN BANK LI"
  },
  {
    "BankId": 666,
    "BankName": "THE TALOD NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1287,
    "BankName": "THE TALOD NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1588,
    "BankName": "THE TAMIL NADU STATE APEX COOPERATIVE BANK"
  },
  {
    "BankId": 1589,
    "BankName": "THE TAMILNADU INDUSTRIAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 313,
    "BankName": "THE TAPINDU URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1590,
    "BankName": "THE TARN TARAN CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 777,
    "BankName": "THE TASGAON URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1699,
    "BankName": "THE TEXCO BANK"
  },
  {
    "BankId": 1591,
    "BankName": "THE THANE BHARAT SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1592,
    "BankName": "THE THANE DISTRICT CENTRAL COOPERATIVE BANK LIMITE"
  },
  {
    "BankId": 1593,
    "BankName": "THE THANJAVUR CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1594,
    "BankName": "THE THIRUVANANTHAPURAM DISTRICT COOPERATIVE BANK L"
  },
  {
    "BankId": 668,
    "BankName": "THE THODUPUZHA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1595,
    "BankName": "THE THOOTHUKUDI DISTRICT CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 1596,
    "BankName": "THE THRISSUR DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1597,
    "BankName": "THE TIRUCHIRAPALLI DISTRICT CENTRAL COOPERATIVE BANK LTD"
  },
  {
    "BankId": 1598,
    "BankName": "THE TIRUNELVELI DISTRICT CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 1599,
    "BankName": "THE TIRUPATI COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1600,
    "BankName": "THE TIRUR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 166,
    "BankName": "THE TIRUVALLA EAST COOPERATIVE BANK"
  },
  {
    "BankId": 1601,
    "BankName": "THE TIRUVALLA EAST COOPERATIVE BANK"
  },
  {
    "BankId": 1602,
    "BankName": "THE TIRUVANNAMALAI DISTRICT CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 1603,
    "BankName": "THE TOWN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 318,
    "BankName": "THE TRICHUR URBAN CO OPERA BANK LIMITED"
  },
  {
    "BankId": 1604,
    "BankName": "THE TRIVANDRUM COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1693,
    "BankName": "THE TURA URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1494,
    "BankName": "THE UDAIPUR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 305,
    "BankName": "THE UDGIR URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1605,
    "BankName": "THE UDUPI COOPERATIVE TOWN BANK"
  },
  {
    "BankId": 1606,
    "BankName": "THE UMRETH URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1607,
    "BankName": "THE UNA PEOPLES COOPERATIVE BANK"
  },
  {
    "BankId": 1282,
    "BankName": "THE UNA PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1280,
    "BankName": "THE UNAVA NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1608,
    "BankName": "THE UNION COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1691,
    "BankName": "THE UNITED COOPERATIVE BANK"
  },
  {
    "BankId": 1609,
    "BankName": "THE UNITED COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1690,
    "BankName": "THE URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 665,
    "BankName": "THE URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1610,
    "BankName": "THE UTTARPARA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 925,
    "BankName": "THE UTTARSANDA PEOPLES COOPERATIVE BANK"
  },
  {
    "BankId": 1275,
    "BankName": "THE VADALI NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 33,
    "BankName": "THE VAIDYANATH URBAN COOPERATIVE BANK, AXIS BANK"
  },
  {
    "BankId": 34,
    "BankName": "THE VAIDYANATH URBAN COOPERATIVE BANK, HDFC BANK"
  },
  {
    "BankId": 301,
    "BankName": "THE VAISH COOPERATIVE ADARSH BANK LIMITED"
  },
  {
    "BankId": 311,
    "BankName": "THE VAISH COOPERATIVE COMM BANK LIMITED"
  },
  {
    "BankId": 1678,
    "BankName": "THE VAISH COOPERATIVE NEW BANK"
  },
  {
    "BankId": 1611,
    "BankName": "THE VAISHALI DISTRICT CENTRAL COOPERATIVE BANK LIM"
  },
  {
    "BankId": 283,
    "BankName": "THE VALLABH VIDYANAGAR COMM COOPERATIVE BANK LIMIT"
  },
  {
    "BankId": 661,
    "BankName": "THE VALSAD MAHILA NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1612,
    "BankName": "THE VARACHHA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1613,
    "BankName": "THE VARDHMAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 28,
    "BankName": "THE VEJALPUR NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 1614,
    "BankName": "THE VELLORE DISTRICT CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1279,
    "BankName": "THE VEPAR UDHYOG VIKAS SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 294,
    "BankName": "THE VERAVAL MERCANTILE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 292,
    "BankName": "THE VERAVAL PEOPLES COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1283,
    "BankName": "THE VIJAPUR NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1615,
    "BankName": "THE VIJAY COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1616,
    "BankName": "THE VILLUPURAM DISTRICT CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1278,
    "BankName": "THE VIRAMGAM MERCANTILE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1617,
    "BankName": "THE VIRUDHUNAGAR DISTRICT CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 912,
    "BankName": "THE VISAKHAPATNAM COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1618,
    "BankName": "THE VISHWESHWAR SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 852,
    "BankName": "THE VITA MERCHANT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 662,
    "BankName": "THE VITA MERCHANTS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 285,
    "BankName": "THE VITA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1619,
    "BankName": "THE VSV COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 310,
    "BankName": "THE VYANKATESHWARA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1620,
    "BankName": "THE WAGHODIYA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1621,
    "BankName": "THE WARANGAL DISTRICT COOPERATIVE CENTRAL BANK LIM"
  },
  {
    "BankId": 278,
    "BankName": "THE WASHIM URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 248,
    "BankName": "THE WAYANAD DIST COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1622,
    "BankName": "THE WEST BENGAL STATE COOPERATIVE BANK"
  },
  {
    "BankId": 280,
    "BankName": "THE WOMENS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1630,
    "BankName": "THE YAMUNA NAGAR CENTRAL CO OPERATIVE BANK LIMITE"
  },
  {
    "BankId": 276,
    "BankName": "THE YASHWANT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1671,
    "BankName": "THE YAVATMAL DCC BANK"
  },
  {
    "BankId": 273,
    "BankName": "THE YAVATMAL MAHILA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 909,
    "BankName": "THE YAVATMAL URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 29,
    "BankName": "THE YEMMIGANUR COOPERATIVE TOWN BANK LIMITED"
  },
  {
    "BankId": 1631,
    "BankName": "THE ZOROASTRIAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 314,
    "BankName": "TIRUPATI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1632,
    "BankName": "TJSB SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1697,
    "BankName": "TRANSPORT COOPERATIVE BANK"
  },
  {
    "BankId": 1633,
    "BankName": "TRIPURA GRAMIN BANK"
  },
  {
    "BankId": 1634,
    "BankName": "TRIPURA STATE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1406,
    "BankName": "TUMKUR DCC BANK LIMITED"
  },
  {
    "BankId": 1407,
    "BankName": "TUMKUR DISTRICT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 44,
    "BankName": "TUMKUR DISTRICT COOPERATIVE CENTRAL BANK"
  },
  {
    "BankId": 1635,
    "BankName": "TUMKUR GRAIN MERCHANTS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1636,
    "BankName": "TUMKUR VEERASHAIVA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1637,
    "BankName": "UCO BANK"
  },
  {
    "BankId": 664,
    "BankName": "UDAIPUR MAHILA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1638,
    "BankName": "UDGIR URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1639,
    "BankName": "UDHAM SINGH NAGAR DISTRICT COOPERATIVE BANK LIMITE"
  },
  {
    "BankId": 306,
    "BankName": "UDYAM VIKAS SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1692,
    "BankName": "UJJAIN AUDHYOGIK VIKAS NAGRIK BANK"
  },
  {
    "BankId": 1686,
    "BankName": "UJJAIN NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 1685,
    "BankName": "UJJAIN PARASPAR SAHAKARI BANK"
  },
  {
    "BankId": 1640,
    "BankName": "Ujjivan Small Finance Bank Limited"
  },
  {
    "BankId": 1940,
    "BankName": "UJJIVAN SMALL FINANCE BANK LIMITED DHARMANAGAR"
  },
  {
    "BankId": 1641,
    "BankName": "UMA COOPERATIVE BANK"
  },
  {
    "BankId": 1687,
    "BankName": "UMIYA URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1688,
    "BankName": "UMIYA URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 980,
    "BankName": "UMIYA URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1642,
    "BankName": "UNION BANK OF INDIA"
  },
  {
    "BankId": 1872,
    "BankName": "UNION BANK OF INDIA CREDIT CARD"
  },
  {
    "BankId": 1643,
    "BankName": "UNITED BANK OF INDIA"
  },
  {
    "BankId": 1922,
    "BankName": "UNITED BANK OF INDIA, LANGPI DEHANGI RURAL BANK, D"
  },
  {
    "BankId": 1644,
    "BankName": "UNITED INDIA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1689,
    "BankName": "UNITED MERC COOPERATIVE BANK"
  },
  {
    "BankId": 1645,
    "BankName": "UNITED OVERSEAS BANK LIMITED"
  },
  {
    "BankId": 1695,
    "BankName": "UNITED PURI NIMAPRA CENTRAL COOPERATIVE BANK"
  },
  {
    "BankId": 307,
    "BankName": "UNIVERSAL COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 1281,
    "BankName": "UNJHA NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 308,
    "BankName": "URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 693,
    "BankName": "URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1838,
    "BankName": "UTKAL GRAMYA BANK"
  },
  {
    "BankId": 1646,
    "BankName": "UTKARSH SMALL FINANCE BANK"
  },
  {
    "BankId": 1647,
    "BankName": "UTTAR BANGA KSHETRIYA GRAMIN BANK"
  },
  {
    "BankId": 1648,
    "BankName": "UTTAR BIHAR GRAMIN BANK"
  },
  {
    "BankId": 1649,
    "BankName": "UTTAR PRADESH COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1650,
    "BankName": "UTTAR PRADESH STATE COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1933,
    "BankName": "UTTARAKHAND GRAMIN BANK"
  },
  {
    "BankId": 1651,
    "BankName": "UTTARANCHAL GRAMIN BANK"
  },
  {
    "BankId": 849,
    "BankName": "UTTARKASHI ZILA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1652,
    "BankName": "UTTRAKHAND COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1653,
    "BankName": "UTTRAKHAND STATE CO-COPERATIVE BANK LIMITED"
  },
  {
    "BankId": 282,
    "BankName": "V.V.C.C BANK LIMITED"
  },
  {
    "BankId": 1276,
    "BankName": "VADNAGAR NAGARIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1679,
    "BankName": "VAIJAPUR MERCHANTS BANK"
  },
  {
    "BankId": 1683,
    "BankName": "VAISH COOPERATIVE ADARSH BANK"
  },
  {
    "BankId": 36,
    "BankName": "VAISHYA NAGARI SAH BANK LIMITED"
  },
  {
    "BankId": 35,
    "BankName": "VAISHYA NAGARI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 788,
    "BankName": "VAISHYA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 37,
    "BankName": "VALMIKI URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1274,
    "BankName": "VALSAD DISRICT CENTRAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1654,
    "BankName": "VANANCHAL GRAMIN BANK"
  },
  {
    "BankId": 304,
    "BankName": "VANI MERCHANTS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 302,
    "BankName": "VARDHAMAN MAHILA COOPERATIVE URBAN BANK LIMITED"
  },
  {
    "BankId": 296,
    "BankName": "VASAI JANATA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1655,
    "BankName": "VASAI VIKAS SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1682,
    "BankName": "VASANTDADA NAGARI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 290,
    "BankName": "VEERASHAIVA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 284,
    "BankName": "VEPAR UDYOG VIKAS SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 911,
    "BankName": "VIDARBHA MERCHANTS U.C.B. LIMITED"
  },
  {
    "BankId": 1656,
    "BankName": "VIDHARBHA KONKAN GRAMIN BANK LIMITED"
  },
  {
    "BankId": 1570,
    "BankName": "VIDYA BANK"
  },
  {
    "BankId": 299,
    "BankName": "VIDYANAND COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 979,
    "BankName": "VIJAY COMMERCIAL COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 312,
    "BankName": "VIJAY COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1658,
    "BankName": "VIJAYA BANK"
  },
  {
    "BankId": 1873,
    "BankName": "VIJAYA BANK CREDIT CARD"
  },
  {
    "BankId": 1659,
    "BankName": "VIKAS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 289,
    "BankName": "VIKAS SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 796,
    "BankName": "VIKAS SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 297,
    "BankName": "VIKAS SOUHARDA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1660,
    "BankName": "VIKAS URBAN COOPERATIVE BANK"
  },
  {
    "BankId": 1677,
    "BankName": "VIKRAMADITYA NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 659,
    "BankName": "VIKRAMADITYA NAGRIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1680,
    "BankName": "VIMA KAMGAR COOPERATIVE BANK"
  },
  {
    "BankId": 291,
    "BankName": "VIRAJPET PATTANA SAHAKARA BANK"
  },
  {
    "BankId": 183,
    "BankName": "VISAKHAPATNAM MID CORPORATE BANK"
  },
  {
    "BankId": 287,
    "BankName": "VISHWAKALYAN SAHAKAR BANK"
  },
  {
    "BankId": 286,
    "BankName": "VISHWAKARAMA SAHAKARA BANK LIMITED"
  },
  {
    "BankId": 1681,
    "BankName": "VISHWAKARMA SAHAKARI BANK"
  },
  {
    "BankId": 853,
    "BankName": "VISHWANATHRAO PATIL MURGUD SAHAKARI BANK"
  },
  {
    "BankId": 298,
    "BankName": "VISHWAS COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1661,
    "BankName": "VISL EMPLOYEES COOPERATIVE BANK"
  },
  {
    "BankId": 660,
    "BankName": "VIVEKANAND NAGRIK SAHAKARI BANK"
  },
  {
    "BankId": 288,
    "BankName": "VYAPARI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1684,
    "BankName": "VYAPARIK AUDYOGIK SAHAKARI BANK"
  },
  {
    "BankId": 295,
    "BankName": "VYAVASAYIK EVAM AUDHYOGIK SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1676,
    "BankName": "VYAVSAYIK SAHAKARI BANK"
  },
  {
    "BankId": 1662,
    "BankName": "VYSYA COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1675,
    "BankName": "WANA NAGARIK SAHAKARI BANK"
  },
  {
    "BankId": 1674,
    "BankName": "WANA NAGRI SAHAKARI BANK"
  },
  {
    "BankId": 281,
    "BankName": "WANI NAGRI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 30,
    "BankName": "WARANGAL URBAN COOPERATIVE BANK LIMITED, AXIS BANK"
  },
  {
    "BankId": 31,
    "BankName": "WARANGAL URBAN COOPERATIVE BANK LIMITED, ICICI BAN"
  },
  {
    "BankId": 1673,
    "BankName": "WARDHA NAGRI BANK"
  },
  {
    "BankId": 658,
    "BankName": "WARDHA ZILLA PARISHAD EMPLOYEES URBAN COOPERATIVE"
  },
  {
    "BankId": 1663,
    "BankName": "WARDHAMAN URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 279,
    "BankName": "WARDHMAN URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 277,
    "BankName": "WARUD URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1664,
    "BankName": "WESTPAC BANKING CORPORATION"
  },
  {
    "BankId": 1665,
    "BankName": "WOORI BANK"
  },
  {
    "BankId": 1670,
    "BankName": "YADAGIRI LNS COOPERATIVE BANK"
  },
  {
    "BankId": 1666,
    "BankName": "YADRAV COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 39,
    "BankName": "YARAGATTI URBAN COOPERATIVE CREDIT BANK"
  },
  {
    "BankId": 272,
    "BankName": "YASHWANT NAGARI SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 274,
    "BankName": "YEOLA MER COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1668,
    "BankName": "YES BANK"
  },
  {
    "BankId": 1826,
    "BankName": "YES BANK LIMITED, ARUNACHAL PRADESH SCB NAHARLAGUN"
  },
  {
    "BankId": 977,
    "BankName": "YESHWANT URBAN COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 1669,
    "BankName": "YLNS COOPERATIVE URBAN BANK"
  },
  {
    "BankId": 275,
    "BankName": "YOUTH DEVELOPMENT COOPERATIVE BANK LIMITED"
  },
  {
    "BankId": 657,
    "BankName": "ZILA SAHAKARI BANK LIMITED"
  },
  {
    "BankId": 1667,
    "BankName": "ZILA SAHAKARI BANK, YES BANK"
  },
  {
    "BankId": 1938,
    "BankName": "Zila Sahkari Bank Ltd Bulandshahr"
  },
  {
    "BankId": 1886,
    "BankName": "ZILA SAHKARI BANK LTD GHAZIABAD"
  },
  {
    "BankId": 1915,
    "BankName": "ZILA SAHKARI BANK LTD MUZAFFARNAGAR"
  }
];